import React, { Component, KeyboardEvent, ChangeEvent, MouseEvent } from "react";
import {
    Row, Col, Button, Modal, ModalBody, ModalHeader, ModalFooter, Spinner, Nav, NavItem, NavLink, TabContent, TabPane, UncontrolledTooltip, UncontrolledPopover, PopoverBody, Badge, Container, Dropdown, DropdownItem, DropdownMenu, DropdownToggle
} from "reactstrap";
import * as KSLPlusAPI from "../services/KSLPlusAPI"

import Chart from "react-google-charts";
import { GoogleChartWrapper, GoogleChartControl, GoogleViz, ReactGoogleChartProps, ReactGoogleChartEvent, GoogleDataTable, GoogleVizEventName } from "react-google-charts/dist/types";

import { ImgButton } from './ImgButtonComp';

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
    AccordionItemState
} from 'react-accessible-accordion';

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
// @ts-ignores
import BootstrapTable from 'react-bootstrap-table-next';
// @ts-ignore
import cellEditFactory from 'react-bootstrap-table2-editor';
// @ts-ignore
import paginationFactory from 'react-bootstrap-table2-paginator';

import * as Utilities from "./Utilities"


import { env } from '../env';
import '../custom.css';
import { ENGINE_METHOD_PKEY_ASN1_METHS } from "constants";

import { VBTab } from './VBTabComp';

import * as QueryString from "query-string";

const _colors = ['#3366cc', '#dc3912', '#ff9900', '#109618', '#990099', '#0099c6', '#dd4477', '#66aa00', '#b82e2e', '#316395', '#994499', '#22aa99', '#aaaa11', '#6633cc', '#e67300', '#8b0707', '#651067', '#329262', '#5574a6', '#3b3eac', '#b77322', '#16d620', '#b91383', '#f4359e', '#9c5935', '#a9c413', '#2a778d', '#668d1c', '#bea413', '#0c5922', '#743411'];

type State = {
    ready: boolean;
    activeMainTab: string,
    dropDownOpen: boolean,
    tab: string,
    activeDataTabId: string,
    isVisible: boolean,
    alleJahre: boolean,
    fpJahre: boolean,
    chartTyp: number,
    collapsedColumnsA: { [key: string]: boolean },
    collapsedColumnsE: { [key: string]: boolean }
}

type Props = {
    kunde: number,
    gemeinde: number,
    jahr: number,
    plantyp: number,
    planstufe: number,
    verwaltungsansicht: boolean,
    uhconfig: KSLPlusAPI.UhConfigModel | undefined,
    settings: KSLPlusAPI.SettingsModel,
    isVisible: boolean,
    query: string | undefined
}



export class Vorbericht extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.vwHH1 = null;
        this.vwHH2 = null;
        this.E9_1 = null;
        this.E3_1 = null;
        this.E9_2 = null;
        this.E3_2 = null;
        this.dataSets = [];
        this.vbtabs = [];

    }

    node1: any;
    node2: any;
    node3: any;
    node4: any;
    vwHH1: KSLPlusAPI.HaushaltsEbene | null;
    vwHH2: KSLPlusAPI.HaushaltsEbene | null;
    E9_1: KSLPlusAPI.HaushaltsEbene | null | undefined;
    E3_1: KSLPlusAPI.HaushaltsEbene | null | undefined;
    E9_2: KSLPlusAPI.HaushaltsEbene | null | undefined;
    E3_2: KSLPlusAPI.HaushaltsEbene | null | undefined;
    dataSets: KSLPlusAPI.Datensaetze[];
    vbtabs: KSLPlusAPI.Vbtab[];

    state: State = {
        ready: true,
        activeMainTab: "1",
        dropDownOpen: false,
        tab: "",
        activeDataTabId: "",
        isVisible: false,
        alleJahre: false,
        fpJahre: true,
        chartTyp: 0,
        collapsedColumnsA: {  },
        collapsedColumnsE: {  }

    }

    readHH1Data = (tries: number = 0) => {
        var request = new KSLPlusAPI.HaushaltRequest();
        var kunde = 0;
        if (this.props.kunde === undefined)
            return;
        request.kunde = this.props.kunde;
        var gemeinde = 0;
        if (this.props.gemeinde === undefined)
            return;
        request.gemeinde = this.props.gemeinde;
        var jahr = 0;
        if (this.props.jahr === undefined)
            return;
        request.jahr = this.props.jahr;

        request.plantyp = this.props.plantyp;
        request.planstufe = this.props.planstufe;
        request.uhConfig = this.props.uhconfig ? this.props.uhconfig.id : 0;
        request.nurOberebenen = true;
        request.verwaltungsAnsicht = this.props.verwaltungsansicht;

        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";

        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        request.gruppen = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        client.getHaushaltByGruppierung("", request).then((hh) => {
            this.vwHH1 = hh;
            if (hh.unterEbenen !== undefined) {
                this.E9_1 = hh.unterEbenen.find(he => he.untergruppe == 9);
                if (this.E9_1) {
                    this.E9_1.jahre = hh.jahre;
                }
                this.E3_1 = hh.unterEbenen.find(he => he.untergruppe == 3);
                if (this.E3_1) {
                    this.E3_1.jahre = hh.jahre;
                }
            }

            //this.readHH2Data();
            this.readDataSets();
            this.setState({ ready: true });
        }).catch(Reason => {
            if (tries < 3)
                setTimeout(() => { this.readHH1Data(++tries) }, 2000);
            else
                alert("Fehler beim Lesen des Haushalts für Betrachtung nach Gruppierung!");
        });

    }

    readHH2Data = () => {
        var request = new KSLPlusAPI.HaushaltRequest();
        var kunde = 0;
        if (this.props.kunde === undefined)
            return;
        request.kunde = this.props.kunde;
        var gemeinde = 0;
        if (this.props.gemeinde === undefined)
            return;
        request.gemeinde = this.props.gemeinde;
        var jahr = 0;
        if (this.props.jahr === undefined)
            return;
        request.jahr = this.props.jahr;

        request.plantyp = this.props.plantyp;
        request.planstufe = this.props.planstufe;
        request.uhConfig = this.props.uhconfig ? this.props.uhconfig.id : 0;
        request.nurOberebenen = true;

        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";
        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        request.gruppen = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        request.ignorierteGruppen = [800, 801, 802, 803, 804, 805, 806, 807, 808, 86, 91, 201, 202, 203, 204, 205, 206, 207, 208, 28, 31];
        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        client.getHaushaltByGruppierung("", request).then((hh) => {
            this.vwHH2 = hh;
            if (hh.unterEbenen !== undefined) {
                this.E9_2 = hh.unterEbenen.find(he => he.untergruppe == 9);
                this.E3_2 = hh.unterEbenen.find(he => he.untergruppe == 3);
            }
            this.setState({ ready: true });
            this.readDataSets();
        }).catch(Reason => {
        });
    }


    readDataSets = () => {
        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";
        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        client.datensaetze(this.props.kunde, this.props.gemeinde, this.props.jahr, -1, this.props.plantyp === 3 ? 1 : 0, this.props.plantyp, this.props.planstufe, "").then((sets) => {
            this.dataSets = sets;
            this.readMainTabs();
            this.setState({ ready: true });
        }).catch(Reason => {
        });
    }

    readMainTabs = () => {
        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";
        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        client.tabs(this.props.kunde, this.props.gemeinde, this.props.jahr, 1, this.props.plantyp == 3 ? 1 : (this.props.plantyp == 4 ? 2 : 0), "").then((tabs) => {
            this.vbtabs = tabs;
            if (tabs.length > 0 && tabs[0].bezeichnung) {
                this.state.tab = tabs[0].bezeichnung;
                this.state.activeDataTabId = "tab0";
            }
            this.setState({ ready: true });
        }).catch(Reason => {
        });
    }

    readData = () => {
        this.readHH1Data();
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.isVisible !== this.props.isVisible && this.props.isVisible !== this.state.isVisible) {
            this.setState({ activeMainTab: "1" });
            this.parseParams();
        }

        if (prevProps.uhconfig !== this.props.uhconfig && this.props.plantyp === 4) {
            this.readData();
        }

    }

    componentDidMount() {
        this.readData();
        this.parseParams();
    }


    parseParams = () => {
        if (!this.props.query)
            return;

        const params = QueryString.parse(this.props.query);


        if (params.vbt != null) {
            if (Array.isArray(params.vbt))
                this.setState({ activeMainTab: params.vbt[0] });
            else
                this.setState({ activeMainTab: params.vbt });
        }
    }

    createChangeColumn = (field1: string, field2: string, footer1: number, footer2: number, ausgaben: boolean, id: number, sumid: string | undefined, showFooter: boolean = true, text: string = "Vorjahr", pjFarben: boolean = false, jrFarben: boolean = false, f1_1: number | undefined = undefined, f2_2: number|undefined = undefined ) => {
        return {
            dataField: "dummy" + id.toString(),
            text: "+/-",
            headerAlign: 'right',
            align: 'right',
            formatter: (cellContent: string, row: { [key: string]: number }) => {

                var res = Utilities.calcArrowRotAndColor(row[field1], row[field2], ausgaben, this.props.settings, row["untergruppe"], row["ugStellen"]);


                var ttId = row.id ? "kslplus-label-" + id + "_" + row.id : "";
                ttId = ttId + (ausgaben ? "-a" : "-e");

                return (
                    <div>
                        <div id={ttId}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 164 156" width="100%">
                                <g transform={"rotate(" + res.rotation + ", 82, 78)"}>
                                    <path d="m0,86h36v70h92V86h36L82,0" fill={res.color} />
                                </g>
                            </svg>
                        </div>
                        <UncontrolledPopover
                            size="lg"
                            placement="right"
                            target={ttId}
                            trigger="hover"
                            className="kslplus-change-popover">
                            <PopoverBody className="kslplus-change-popover-body">
                                <div className="kslplus-change-popover-headline">{"Veränderung gegenüber " + text + ": " + Utilities.FormatCurrency(res.changeA, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung + " (" + Utilities.FormatCurrency((res.changeP - 1) * 100, 2, 0, '.', ',') + "  %)"}</div>
                            </PopoverBody>
                        </UncontrolledPopover>
                    </div>

                );

            },
            footerStyle: (colum: any, colIndex: any) => {
                if (pjFarben)
                    return { backgroundColor: this.props.settings.hFarbePJ, color: this.props.settings.vFarbePJ };

                if (jrFarben)
                    return { backgroundColor: this.props.settings.hFarbeJR, color: this.props.settings.vFarbeJR };

                return {};
            },
            headerStyle: (colum: any, colIndex: any) => {
                if (pjFarben)
                    return { width: "40px", backgroundColor: this.props.settings.hFarbePJ, color: this.props.settings.vFarbePJ };

                if (jrFarben)
                    return { width: "40px", backgroundColor: this.props.settings.hFarbeJR, color: this.props.settings.vFarbeJR };

                return { width: "40px" };
            },
            style: (colum: any, colIndex: any) => {
                if (pjFarben)
                    return { width: "40px", backgroundColor: this.props.settings.hFarbePJ, color: this.props.settings.vFarbePJ };

                if (jrFarben)
                    return { width: "40px", backgroundColor: this.props.settings.hFarbeJR, color: this.props.settings.vFarbeJR };

                return { width: "40px" };
            },
            footer: showFooter ? id : undefined,
            footerAlign: 'right',
            footerFormatter: (column: any, columnIndex: number) => {
                var res = Utilities.calcArrowRotAndColor(footer1, footer2, ausgaben, this.props.settings);
                var ttId = "kslplus-label-column-" + sumid + "-" + (ausgaben ? "a-" : "e-") + columnIndex;

                var ttId1 = "kslplus-label-column-" + sumid + "-" + (ausgaben ? "a-1" : "e-1") + columnIndex;
                var res1: any;
                if (f1_1 !== undefined && f2_2 !== undefined  )
                {
                    res1 = Utilities.calcArrowRotAndColor(f1_1, f2_2, ausgaben, this.props.settings);                    
                }

                return (
                    <div>                        
                        <div id={ttId}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 164 156" width="100%">
                                <g transform={"rotate(" + res.rotation + ", 82, 78)"}>
                                    <path d="m0,86h36v70h92V86h36L82,0" fill={res.color} />
                                </g>
                            </svg>
                        </div>
                        <UncontrolledPopover
                            size="lg"
                            placement="right"
                            target={ttId}
                            trigger="hover"
                            className="kslplus-change-popover">
                            <PopoverBody className="kslplus-change-popover-body">
                                <div className="kslplus-change-popover-headline">{"Veränderung gegenüber " + text + ": " + Utilities.FormatCurrency(res.changeA, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung + " (" + Utilities.FormatCurrency((res.changeP - 1) * 100, 2, 0, '.', ',') + "  %)"}</div>
                            </PopoverBody>
                        </UncontrolledPopover>
                        {f1_1 !== undefined && f2_2 !== undefined &&
                            <>
                                <div id={ttId1}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 164 156" width="100%">
                                        <g transform={"rotate(" + res1.rotation + ", 82, 78)"}>
                                            <path d="m0,86h36v70h92V86h36L82,0" fill={res1.color} />
                                        </g>
                                    </svg>
                                </div>
                                <UncontrolledPopover
                                    size="lg"
                                    placement="right"
                                    target={ttId1}
                                    trigger="hover"
                                    className="kslplus-change-popover">
                                    <PopoverBody className="kslplus-change-popover-body">
                                    <div className="kslplus-change-popover-headline">{"Veränderung gegenüber " + text + ": " + Utilities.FormatCurrency(res1.changeA, this.props.settings.nk, 3, '.', ',') + " " + this.props.settings.waehrung + " (" + Utilities.FormatCurrency((res1.changeP - 1) * 100, 2, 0, '.', ',') + "  %)"}</div>
                                    </PopoverBody>
                                </UncontrolledPopover>
                            </>

                        }
                    </div>

                );
            }
        };
    }

    createDataColumnUH = (field: string, jahr: number, footer: number, footer2: number | undefined, id: number, text: string, hidden: boolean = false, ttE: boolean = false, ttF: boolean = false, testfield: string = "", komfield: string = "", pkTip: boolean = false, gsTip: boolean = false, ausgefuehrtTip: boolean = false, ausgaben: boolean = false) => {
        text = this.props.settings.tabellenBezeichner?.[text] ?? text;

        return {
            dataField: field,
            text: text + " " + jahr + " (" + this.props.settings.waehrung + ")",
            headerAlign: 'right',
            align: 'right',
            hidden: hidden,
            headerFormatter: (column: any, columnIndex: any) => {
                if (ausgefuehrtTip) {

                    var ttId = "header-tt-gl-erg-" + field;

                    return (
                        <div>
                            <div id={ttId} className="kslplus-tabellen-header"><div className="kslplus-tabellen-header-sub1">{text + " " + jahr}</div><div className="kslplus-tabellen-header-sub2">({this.props.settings.waehrung})</div></div>

                            <UncontrolledPopover
                                size="xl"
                                placement="right"
                                target={ttId}
                                trigger="hover"
                                className="kslplus-header-popover">
                                <PopoverBody className="kslplus-header-popover-body">
                                    <Container>
                                        <div><div className="kslplus-header-tt-block1">Ausgeführt errechnet sich wie folgt:</div></div>
                                        <br />

                                        {this.props.uhconfig && this.props.uhconfig.verfuegtSpaltenDic &&
                                            Utilities.createAusgefuehrtTooltipItems(this.props.uhconfig.verfuegtSpaltenDic, this.props.settings.importFormat)
                                        }


                                    </Container>
                                </PopoverBody>
                            </UncontrolledPopover>
                        </div>
                    );
                }
                else if (gsTip) {

                    var ttId = "header-tt-gl-erg-" + field;

                    return (
                        <div>
                            <div id={ttId} className="kslplus-tabellen-header"><div className="kslplus-tabellen-header-sub1">{text + " " + jahr}</div><div className="kslplus-tabellen-header-sub2">({this.props.settings.waehrung})</div></div>

                            <UncontrolledPopover
                                size="xl"
                                placement="right"
                                target={ttId}
                                trigger="hover"
                                className="kslplus-header-popover">
                                <PopoverBody className="kslplus-header-popover-body">
                                    <Container>
                                        <div><div className="kslplus-header-tt-block1">Der fortgeschriebene Ansatz errechnet sich wie folgt:</div></div>
                                        <br />

                                        {this.props.uhconfig && this.props.uhconfig.fortAnsatzSpaltenDic &&
                                            Utilities.createGSTooltipItems(this.props.uhconfig.fortAnsatzSpaltenDic, this.props.settings.importFormat)
                                        }


                                    </Container>
                                </PopoverBody>
                            </UncontrolledPopover>
                        </div>
                    );
                }
                else if (ttE) {

                    var ttId = "header-tt-gl-erg-" + field;

                    return (
                        <div>
                            <div id={ttId} className="kslplus-tabellen-data">{text + " " + jahr + " (" + this.props.settings.waehrung + ")"} </div>

                            <UncontrolledPopover
                                size="xl"
                                placement="right"
                                target={ttId}
                                trigger="hover"
                                className="kslplus-header-popover">
                                <PopoverBody className="kslplus-header-popover-body">
                                    <Container>
                                        <div><div className="kslplus-header-tt-block1">Das Ergebnis (Rechnungsergebnis) errechnet sich wie folgt:</div></div>
                                        <br />
                                        <div className="kslplus-header-tt-block"><div className="kslplus-label">Ausgeführtes Soll auf lfd. Ansatz</div></div>
                                        <div className="kslplus-header-tt-block"><div className="kslplus-sign">-&nbsp;</div><div className="kslplus-label">Abgang auf Kassenreste aus Vj.</div></div>
                                        <div className="kslplus-header-tt-block"><div className="kslplus-sign">+&nbsp;</div><div className="kslplus-label">Neue Haushaltsreste</div></div>
                                        <div className="kslplus-header-tt-block"><div className="kslplus-sign">-&nbsp;</div><div className="kslplus-label">Abgang Haushaltsreste aus Vj.</div></div>


                                    </Container>
                                </PopoverBody>
                            </UncontrolledPopover>
                        </div>
                    );
                }
                else if (ttF) {

                    var ttId = "header-tt-gl-fort-" + field;

                    return (
                        <div>
                            <div id={ttId} className="kslplus-tabellen-data">{text + " " + jahr + " (" + this.props.settings.waehrung + ")"} </div>
                            <UncontrolledPopover
                                size="xl"
                                placement="right"
                                target={ttId}
                                trigger="hover"
                                className="kslplus-header-popover">
                                <PopoverBody className="kslplus-header-popover-body">
                                    <Container>
                                        <div><div className="kslplus-header-tt-block1">Der fortgeschriebene Ansatz errechnet sich wie folgt:</div></div>
                                        <br />
                                        <div className="kslplus-header-tt-block"><div className="kslplus-label">Ansatz</div></div>
                                        <div className="kslplus-header-tt-block"><div className="kslplus-sign">+/-</div><div className="kslplus-label">Nachtragswerte</div></div>
                                        <div className="kslplus-header-tt-block"><div className="kslplus-sign">+/-</div><div className="kslplus-label">Sollveränderungen</div></div>
                                    </Container>
                                </PopoverBody>
                            </UncontrolledPopover>
                        </div>
                    );
                }
                else {
                    return (
                        <div className="kslplus-tabellen-data">{text + " " + jahr + " (" + this.props.settings.waehrung + ")"} </div>
                    );
                }
            },
            formatter: (cellContent: string, row: { [key: string]: number }) => {
                if (gsTip && this.props.uhconfig && this.props.uhconfig.fortAnsatzSpaltenDic) {
                    var items = Utilities.createGSValTooltipItems(this.props.uhconfig.fortAnsatzSpaltenDic, this.props.settings.importFormat, row, this.props.settings.nk, ausgaben);
                    if (items.length > 0) {
                        var ttId = row.id ? "kslplus-gesamtsoll-" + field + row.id : "";
                        return (<div><div id={ttId} className="kslplus-tabellen-data">{Utilities.FormatCurrency(row[field] as number, this.props.settings.nk, 3, '.', ',')} </div><UncontrolledPopover
                            size="xl"
                            placement="right"
                            target={ttId}
                            trigger="hover"
                            className="kslplus-header-popover">
                            <PopoverBody className="kslplus-header-popover-body">
                                <Container className="kslplus-hhttwerte-popover-block">
                                    <div><div className="kslplus-header-tt-block1">Der fortgeschriebene Ansatz errechnet sich wie folgt:</div></div>
                                    <br />
                                    {items}

                                </Container>
                            </PopoverBody>
                        </UncontrolledPopover>
                        </div>);
                    }
                }

                if (ausgefuehrtTip && this.props.uhconfig && this.props.uhconfig.verfuegtSpaltenDic) {

                    var items = Utilities.createAusgefuehrtValTooltipItems(this.props.uhconfig.verfuegtSpaltenDic, this.props.settings.importFormat, row, this.props.settings.nk, ausgaben);

                    if (items.length > 0) {
                        var ttId = row.id ? "kslplus-ausgefuert-" + field + row.id : "";

                        return (<div><div id={ttId} className="kslplus-tabellen-data">{Utilities.FormatCurrency(row[field] as number, this.props.settings.nk, 3, '.', ',')} </div><UncontrolledPopover
                            size="xl"
                            placement="right"
                            target={ttId}
                            trigger="hover"
                            className="kslplus-header-popover">
                            <PopoverBody className="kslplus-header-popover-body">
                                <Container className="kslplus-hhttwerte-popover-block">
                                    <div><div className="kslplus-header-tt-block1">Ausgeführt errechnet sich wie folgt:</div></div>
                                    <br />

                                    {items}


                                </Container>
                            </PopoverBody>
                        </UncontrolledPopover>
                        </div>
                        );
                    }
                }


                return (
                    <div className="kslplus-tabellen-data">{Utilities.FormatCurrency(row[field], this.props.settings.nk, 3, '.', ',')} </div>
                );

            },
            footer: id,
            footerAlign: 'right',
            footerFormatter: (column: any, columnIndex: any) => {
                if (footer2 !== undefined)
                    return (<div><div className="kslplus-tabellen-footer">{Utilities.FormatCurrency(footer, this.props.settings.nk, 3, '.', ',')} </div><div className="kslplus-tabellen-footer">{Utilities.FormatCurrency(footer2, this.props.settings.nk, 3, '.', ',')} </div></div>);

                return (
                    <div className="kslplus-tabellen-footer">{Utilities.FormatCurrency(footer, this.props.settings.nk, 3, '.', ',')} </div>
                );
            },
            style: (cell: any, row: { [key: string]: number }, rowIndex: number, colIndex: number) => {
                if (testfield != "" && row[testfield])
                    return { backgroundColor: this.props.uhconfig && this.props.uhconfig.hfarbeProgMan ? this.props.uhconfig.hfarbeProgMan : 'lightcoral', color: this.props.uhconfig && this.props.uhconfig.vfarbeProgMan ? this.props.uhconfig.vfarbeProgMan : 'black' }
            }
        };
    }


    createDataColumnJR = (field: string, jahr: number, footer: number, footer2: number | undefined, id: number, text: string, ttE: boolean = false, ttF: boolean = false) => {
        text = this.props.settings.tabellenBezeichner?.[text] ?? text;

        return {
            dataField: field,
            text: text + " " + jahr + " (" + this.props.settings.waehrung + ")",
            headerAlign: 'right',
            align: 'right',
            headerFormatter: (column: any, columnIndex: any) => {
                if (ttE) {

                    var ttId = "header-tt-gl-erg-" + field;

                    return (
                        <div>
                            <div id={ttId} className="kslplus-tabellen-data">{text + " " + jahr + " (" + this.props.settings.waehrung + ")"} </div>

                            <UncontrolledPopover
                                size="xl"
                                placement="right"
                                target={ttId}
                                trigger="hover"
                                className="kslplus-header-popover">
                                <PopoverBody className="kslplus-header-popover-body">
                                    <Container>
                                        <div><div className="kslplus-header-tt-block1">Das Ergebnis (Rechnungsergebnis) errechnet sich wie folgt:</div></div>
                                        <br />
                                        {this.props.settings.jrSettings && Utilities.createErgTooltipItems(this.props.settings.jrSettings)}
                                    </Container>
                                </PopoverBody>
                            </UncontrolledPopover>
                        </div>
                    );
                }
                else if (ttF) {

                    var ttId = "header-tt-gl-fort-" + field;

                    return (
                        <div>
                            <div id={ttId} className="kslplus-tabellen-data">{text + " " + jahr + " (" + this.props.settings.waehrung + ")"} </div>
                            <UncontrolledPopover
                                size="xl"
                                placement="right"
                                target={ttId}
                                trigger="hover"
                                className="kslplus-header-popover">
                                <PopoverBody className="kslplus-header-popover-body">
                                    <Container>
                                        <div><div className="kslplus-header-tt-block1">Der fortgeschriebene Ansatz errechnet sich wie folgt:</div></div>
                                        <br />
                                        {this.props.settings.jrSettings && Utilities.createFATooltipItems(this.props.settings.jrSettings)}
                                    </Container>
                                </PopoverBody>
                            </UncontrolledPopover>
                        </div>
                    );
                }
                else {
                    return (
                        <div className="kslplus-tabellen-data">{text + " " + jahr + " (" + this.props.settings.waehrung + ")"} </div>
                    );
                }
            },
            style: (cell: any, row: { [key: string]: number }, rowIndex: number, colIndex: number) => {
                if (this.props.plantyp === 3 && jahr - this.props.jahr === 0) {
                    return { backgroundColor: this.props.settings.hFarbeJR, color: this.props.settings.vFarbeJR };
                }

                return {};
            },
            headerStyle: (colum: any, colIndex: any) => {
                if (this.props.plantyp === 3 && jahr - this.props.jahr === 0) {
                    return { backgroundColor: this.props.settings.hFarbeJR, color: this.props.settings.vFarbeJR };
                }

                return {};
            },
            formatter: (cellContent: string, row: { [key: string]: number }) => {
                return (
                    <div className="kslplus-tabellen-data">{Utilities.FormatCurrency(row[field], this.props.settings.nk, 3, '.', ',')} </div>
                );

            },
            footer: id,
            footerStyle: (cell: any, row: { [key: string]: number }, rowIndex: number, colIndex: number) => {
                if (this.props.plantyp === 3 && jahr - this.props.jahr === 0) {
                    return { backgroundColor: this.props.settings.hFarbeJR, color: this.props.settings.vFarbeJR };
                }

                return {};

            },
            footerAlign: 'right',
            footerFormatter: (column: any, columnIndex: any) => {
                if (footer2 !== undefined)
                    return (<div><div className="kslplus-tabellen-footer">{Utilities.FormatCurrency(footer, this.props.settings.nk, 3, '.', ',')} </div><div className="kslplus-tabellen-footer">{Utilities.FormatCurrency(footer2, this.props.settings.nk, 3, '.', ',')} </div></div>);

                return (
                    <div className="kslplus-tabellen-footer">{Utilities.FormatCurrency(footer, this.props.settings.nk, 3, '.', ',')} </div>
                );
            }
        };
    }

    createDataColumn = (field: string, jahr: number, footer: number, footer2: number | undefined, id: number, text: string = "") => {
        //var text = "";
        if (text === "") {
            if (jahr - this.props.jahr == -2 && this.props.plantyp < 3 && this.props.settings.vvjVorl)
                text = "vorl. Ergebnis";
            else if (jahr - this.props.jahr < -1)
                text = "Ergebnis";
            else if (jahr - this.props.jahr > (this.props.settings.doppelhaushalt ? 1 : 0))
                text = "Finanzplan";
            else
                text = "Ansatz";
        }

        text = this.props.settings.tabellenBezeichner?.[text] ?? text;

        return {
            dataField: field,
            text: text + " "+ jahr + " (" + this.props.settings.waehrung + ")",
            headerAlign: 'right',
            align: 'right',
            footerStyle: (cell: any, row: { [key: string]: number }, rowIndex: number, colIndex: number) => {
                if ((this.props.plantyp === 1 || this.props.plantyp === 2) && (jahr - this.props.jahr === 0 || this.props.settings.doppelhaushalt && jahr - this.props.jahr === 1)) {
                    return { backgroundColor: this.props.settings.hFarbePJ, color: this.props.settings.vFarbePJ };
                }
                return {};

            },
            formatter: (cellContent: string, row: { [key: string]: number }) => {
                var nk = this.props.settings.nk ?? 2;
                if ((this.props.plantyp === 1 || this.props.plantyp === 2) && (jahr - this.props.jahr > -2) && this.props.settings.ansatzOhneDS && !text.startsWith("Ergebnis")) {
                    nk = 0;
                }

                return (
                    <div className="kslplus-tabellen-data">{Utilities.FormatCurrency(row[field], nk, 3, '.', ',')} </div>
                );

            },
            footer: id,
            footerAlign: 'right',
            footerFormatter: (column: any, columnIndex: any) => {
                var nk = this.props.settings.nk ?? 2;
                if ((this.props.plantyp === 1 || this.props.plantyp === 2) && (jahr - this.props.jahr > -2) && this.props.settings.ansatzOhneDS && !text.startsWith("Ergebnis")) {
                    nk = 0;
                }


                if (footer2 !== undefined)
                    return (<div><div className="kslplus-tabellen-footer">{Utilities.FormatCurrency(footer, nk, 3, '.', ',')} </div><div className="kslplus-tabellen-footer">{Utilities.FormatCurrency(footer2, nk, 3, '.', ',')} </div></div>);

                return (
                    <div className="kslplus-tabellen-footer">{Utilities.FormatCurrency(footer, nk, 3, '.', ',')} </div>
                );
            },
            style: (cell: any, row: { [key: string]: number }, rowIndex: number, colIndex: number) => {
                if ((this.props.plantyp === 1 || this.props.plantyp === 2) && (jahr - this.props.jahr === 0 || this.props.settings.doppelhaushalt && jahr - this.props.jahr === 1)) {
                    return { backgroundColor: this.props.settings.hFarbePJ, color: this.props.settings.vFarbePJ };
                }

                //return { width: '15%' };
            },
            headerStyle: (colum: any, colIndex: any) => {
                if ((this.props.plantyp === 1 || this.props.plantyp === 2) && (jahr - this.props.jahr === 0 || this.props.settings.doppelhaushalt && jahr - this.props.jahr === 1)) {
                    return { backgroundColor: this.props.settings.hFarbePJ, color: this.props.settings.vFarbePJ };
                }
                else
                    return {};
            }
        };
    }

    createDataPercentColumn = (field: string, field1: string, jahr: number, id: number, text: string = "", hidden: boolean = false, ttE: boolean = false, ttF: boolean = false, footVal: number, footVal1: number, footVal_1: number | undefined = undefined, footVal1_1: number | undefined = undefined) => {
        if (text == "") {
            if (jahr - this.props.jahr < -1)
                text = "Ergebnis";
            else if (jahr - this.props.jahr > (this.props.settings.doppelhaushalt ? 1 : 0))
                text = "Finanzplan";
            else
                text = "Ansatz";
        }

        text = this.props.settings.tabellenBezeichner?.[text] ?? text;

        return {
            dataField: field,
            text: text + " " + jahr + " (%)",
            headerAlign: 'right',
            align: 'right',
            hidden: hidden,
            headerFormatter: (column: any, columnIndex: any) => {
                return (
                    <div className="kslplus-tabellen-header"><div className="kslplus-tabellen-header-sub1">{text + " " + jahr}</div><div className="kslplus-tabellen-header-sub2">(%)</div></div>
                );
            },
            formatter: (cellContent: string, row: { [key: string]: number }) => {
                if (Math.round(row[field] * 100) / 100 === 0)
                    return (
                        <div className="kslplus-tabellen-data">0,00</div>
                    );
                else if (row[field1] === 0 && row[field] < 0) {
                    return (<div className="kslplus-tabellen-data">-Ꝏ</div>);
                }
                else if (row[field1] === 0) {

                    return (<div className="kslplus-tabellen-data">Ꝏ</div>);
                }
                else
                    return (
                        <div className="kslplus-tabellen-data">{Utilities.FormatCurrency(row[field] / row[field1] * 100.0, 2, 3, '.', ',')}</div>
                    );

            },
            footer: id,
            footerAlign: 'right',
            footerFormatter: (column: any, columnIndex: any) => {
                var text = "";
                if (Math.round(footVal * 100) / 100 === 0)
                    text = "0,00";
                else if (footVal1 === 0 && footVal < 0)
                    text = "-Ꝏ";                
                else if (footVal1 === 0) 
                    text = "Ꝏ";
                else
                    text = Utilities.FormatCurrency(footVal / footVal1 * 100.0, 2, 3, '.', ',');
                    
                var text1 = "";
                if (footVal_1 !== undefined && footVal1_1 !== undefined) {
                    if (Math.round(footVal_1 * 100) / 100 === 0)
                        text1 = "0,00";
                    else if (footVal1_1 === 0 && footVal_1 < 0)
                         text1 = "-Ꝏ";                   
                    else if (footVal1_1 === 0) 

                        text1 = "Ꝏ";                    
                    else 
                        text1 = Utilities.FormatCurrency(footVal_1 / footVal1_1 * 100.0, 2, 3, '.', ',');                    
                }

                if (text1 != "")
                    return (
                        <div><div className="kslplus-tabellen-footer">{text}</div><div className="kslplus-tabellen-footer">{text1}</div></div>
                    );

                return (
                    <div className="kslplus-tabellen-footer">{text}</div>
                );
                
            }
        };
    }

    createColumnsJR = (data: KSLPlusAPI.HaushaltsEbene | null, totalSum: KSLPlusAPI.HaushaltsEbene, totalSub: KSLPlusAPI.HaushaltsEbene | null | undefined, totalHaben: KSLPlusAPI.HaushaltsEbene | null, totalHabenSub: KSLPlusAPI.HaushaltsEbene | null, ausgaben: boolean, gesamtHH: boolean = false, gesamtVWHH: boolean = false) => {
        var columns = [];
        columns.push({
            dataField: 'bezeichnung',            
            text: (gesamtHH ? (gesamtVWHH ? "VWHH " : "VMHH ") : "") + (ausgaben ? "Ausgaben/Bezeichnung" : "Einnahmen" + "/Bezeichnung"),
            headerStyle: (colum: any, colIndex: any) => {
                return { minWidth: (gesamtHH ? "240px" : "180px"), textAlign: 'left' };
            },

            style: (colum: any, colIndex: any) => {
                return { minWidth: (gesamtHH ? "240px" : "180px") };
            },
            footer: "1",
            footerFormatter: (column: any, columnIndex: any) => {
                if (gesamtHH) {
                    if (ausgaben) {
                        if (!gesamtVWHH)
                            return (<div><div>VMHH Ausgaben gesamt</div><div>VWHH und VMHH Ausgaben gesamt</div></div>);

                        return (<div>VWHH Ausgaben gesamt</div>);
                    }


                    if (!gesamtVWHH)
                        return (<div><div>VMHH Einnahmen gesamt</div><div>VWHH und VMHH Einnahmen gesamt</div></div>);

                    return (<div>VWHH Einnahmen gesamt</div>);
                }


                if (ausgaben)
                    return (<div><div>Ausgaben gesamt</div><div>Ergebnis E-A</div></div>);

                return <div>Einnahmen gesamt</div>;
            }
        });

        if (data == null)
            return columns;

        if (!data.jahre)
            return columns;

        var id = 2;
        if (ausgaben) {
            var fieldPrev: string | undefined;
            var sumPrev = 0;
            var sumGPrev = 0;

            if (data.jahre.findIndex(d => d == this.props.jahr - 4) >= 0 && totalSum.ergebnisPJM4_haben != null && totalSum.ergebnisPJM4_soll != null && totalSum.ergebnisPJM4_soll != 0 && data.ergebnisPJM4_haben != null && data.ergebnisPJM4_soll != null && data.ergebnisPJM4_soll != 0 && totalHaben != null && totalHaben.ergebnisPJM4_haben != null && totalHaben.ergebnisPJM4_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM4_haben != undefined ? totalSub.ergebnisPJM4_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM4_soll != undefined ? totalSub.ergebnisPJM4_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.ergebnisPJM4_haben != undefined ? totalHabenSub.ergebnisPJM4_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnJR("ergebnisPJM4_soll", this.props.jahr - 4, totalSum.ergebnisPJM4_soll - subsoll, this.vwHH1?.ergebnisPJM4_soll ?? 0, id, "Ergebnis"));
                    else
                        columns.push(this.createDataColumnJR("ergebnisPJM4_soll", this.props.jahr - 4, totalSum.ergebnisPJM4_soll - subsoll, undefined, id, "Ergebnis"));
                else
                    columns.push(this.createDataColumnJR("ergebnisPJM4_soll", this.props.jahr - 4, totalSum.ergebnisPJM4_soll - subsoll, totalHaben.ergebnisPJM4_haben - totalSum.ergebnisPJM4_soll - subErgebnis + subsoll, id, "Ergebnis"));
                id++;
                if (fieldPrev && id > 3) {
                    columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM4_soll", sumPrev, totalSum.ergebnisPJM4_soll - subsoll, true, id, totalSum.id, true));
                    id++;
                }
                fieldPrev = "ergebnisPJM4_soll";
                sumPrev = totalSum.ergebnisPJM4_soll - subsoll;
                sumGPrev = this.vwHH1?.ergebnisPJM4_soll ?? 0;
            }
            else {
                fieldPrev = undefined;
            }


            if (data.jahre.findIndex(d => d == this.props.jahr - 3) >= 0 && totalSum.ergebnisPJM3_haben != null && totalSum.ergebnisPJM3_soll != null && totalSum.ergebnisPJM3_soll != 0 && data.ergebnisPJM3_haben != null && data.ergebnisPJM3_soll != null && data.ergebnisPJM3_soll != 0 && totalHaben != null && totalHaben.ergebnisPJM3_haben != null && totalHaben.ergebnisPJM3_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM3_haben != undefined ? totalSub.ergebnisPJM3_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM3_soll != undefined ? totalSub.ergebnisPJM3_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.ergebnisPJM3_haben != undefined ? totalHabenSub.ergebnisPJM3_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnJR("ergebnisPJM3_soll", this.props.jahr - 3, totalSum.ergebnisPJM3_soll - subsoll, this.vwHH1?.ergebnisPJM3_soll ?? 0, id, "Ergebnis"));
                    else
                        columns.push(this.createDataColumnJR("ergebnisPJM3_soll", this.props.jahr - 3, totalSum.ergebnisPJM3_soll - subsoll, undefined, id, "Ergebnis"));
                else
                    columns.push(this.createDataColumnJR("ergebnisPJM3_soll", this.props.jahr - 3, totalSum.ergebnisPJM3_soll - subsoll, totalHaben.ergebnisPJM3_haben - totalSum.ergebnisPJM3_soll - subErgebnis + subsoll, id, "Ergebnis"));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM3_soll", sumPrev, totalSum.ergebnisPJM3_soll - subsoll, true, id, totalSum.id, true, "Vorjahr", false, false, sumGPrev, this.vwHH1?.ergebnisPJM3_soll ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM3_soll", sumPrev, totalSum.ergebnisPJM3_soll - subsoll, true, id, totalSum.id, true));
                    id++;
                }
                fieldPrev = "ergebnisPJM3_soll";
                sumPrev = totalSum.ergebnisPJM3_soll - subsoll;
                sumGPrev = this.vwHH1?.ergebnisPJM3_soll ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

            if (data.jahre.findIndex(d => d == this.props.jahr - 2) >= 0 && totalSum.ergebnisPJM2_haben != null && totalSum.ergebnisPJM2_soll != null && totalSum.ergebnisPJM2_soll != 0 && data.ergebnisPJM2_haben != null && data.ergebnisPJM2_soll != null && data.ergebnisPJM2_soll != 0 && totalHaben != null && totalHaben.ergebnisPJM2_haben != null && totalHaben.ergebnisPJM2_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM2_haben != undefined ? totalSub.ergebnisPJM2_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM2_soll != undefined ? totalSub.ergebnisPJM2_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.ergebnisPJM2_haben != undefined ? totalHabenSub.ergebnisPJM2_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnJR("ergebnisPJM2_soll", this.props.jahr - 2, totalSum.ergebnisPJM2_soll - subsoll, this.vwHH1?.ergebnisPJM2_soll ?? 0, id, "Ergebnis"));
                    else
                        columns.push(this.createDataColumnJR("ergebnisPJM2_soll", this.props.jahr - 2, totalSum.ergebnisPJM2_soll - subsoll, undefined, id, "Ergebnis"));
                else
                    columns.push(this.createDataColumnJR("ergebnisPJM2_soll", this.props.jahr - 2, totalSum.ergebnisPJM2_soll - subsoll, totalHaben.ergebnisPJM2_haben - totalSum.ergebnisPJM2_soll - subErgebnis + subsoll, id, "Ergebnis"));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM2_soll", sumPrev, totalSum.ergebnisPJM2_soll - subsoll, true, id, totalSum.id, true, "Vorjahr", false, false, sumGPrev, this.vwHH1?.ergebnisPJM2_soll ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM2_soll", sumPrev, totalSum.ergebnisPJM2_soll - subsoll, true, id, totalSum.id, true));
                    id++;
                }
                fieldPrev = "ergebnisPJM2_soll";
                sumPrev = totalSum.ergebnisPJM2_soll - subsoll;
                sumGPrev = this.vwHH1?.ergebnisPJM2_soll ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

            if (data.jahre.findIndex(d => d == this.props.jahr - 1) >= 0 && totalSum.ergebnisPJM1_haben != null && totalSum.ergebnisPJM1_soll != null && totalSum.ergebnisPJM1_soll != 0 && data.ergebnisPJM1_haben != null && data.ergebnisPJM1_soll != null && data.ergebnisPJM1_soll != 0 && totalHaben != null && totalHaben.ergebnisPJM1_haben != null && totalHaben.ergebnisPJM1_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM1_haben != undefined ? totalSub.ergebnisPJM1_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM1_soll != undefined ? totalSub.ergebnisPJM1_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.ergebnisPJM1_haben != undefined ? totalHabenSub.ergebnisPJM1_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnJR("ergebnisPJM1_soll", this.props.jahr - 1, totalSum.ergebnisPJM1_soll - subsoll, this.vwHH1?.ergebnisPJM1_soll ?? 0, id, "Ergebnis"));
                    else
                        columns.push(this.createDataColumnJR("ergebnisPJM1_soll", this.props.jahr - 1, totalSum.ergebnisPJM1_soll - subsoll, undefined, id, "Ergebnis"));
                else
                    columns.push(this.createDataColumnJR("ergebnisPJM1_soll", this.props.jahr - 1, totalSum.ergebnisPJM1_soll - subsoll, totalHaben.ergebnisPJM1_haben - totalSum.ergebnisPJM1_soll - subErgebnis + subsoll, id, "Ergebnis"));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM1_soll", sumPrev, totalSum.ergebnisPJM1_soll - subsoll, true, id, totalSum.id, true, "Vorjahr", false, false, sumGPrev, this.vwHH1?.ergebnisPJM1_soll ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM1_soll", sumPrev, totalSum.ergebnisPJM1_soll - subsoll, true, id, totalSum.id, true));
                    id++;
                }
                fieldPrev = "ergebnisPJM1_soll";
                sumPrev = totalSum.ergebnisPJM1_soll - subsoll;
                sumGPrev = this.vwHH1?.ergebnisPJM1_soll ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

            if (data.jahre.findIndex(d => d == this.props.jahr) >= 0 && totalSum.ansatzPJfort_haben != null && totalSum.ansatzPJfort_soll != null && totalSum.ansatzPJfort_soll != 0 && data.ansatzPJfort_haben != null && data.ansatzPJfort_soll != null && data.ansatzPJfort_soll != 0 && totalHaben != null && totalHaben.ansatzPJfort_haben != null && totalHaben.ansatzPJfort_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ansatzPJfort_haben != undefined ? totalSub.ansatzPJfort_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.ansatzPJfort_soll != undefined ? totalSub.ansatzPJfort_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.ansatzPJfort_haben != undefined ? totalHabenSub.ansatzPJfort_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnJR("ansatzPJfort_soll", this.props.jahr, totalSum.ansatzPJfort_soll - subsoll, this.vwHH1?.ansatzPJfort_soll ?? 0, id, "Fortgeschriebener Ansatz", false, true));
                    else
                        columns.push(this.createDataColumnJR("ansatzPJfort_soll", this.props.jahr, totalSum.ansatzPJfort_soll - subsoll, undefined, id, "Fortgeschriebener Ansatz", false, true));
                else
                    columns.push(this.createDataColumnJR("ansatzPJfort_soll", this.props.jahr, totalSum.ansatzPJfort_soll - subsoll, totalHaben.ansatzPJfort_haben - totalSum.ansatzPJfort_soll - subErgebnis + subsoll, id, "Fortgeschriebener Ansatz", false, true));
                id++;

                fieldPrev = "ansatzPJfort_soll";
                sumPrev = totalSum.ansatzPJfort_soll - subsoll;
                sumGPrev = this.vwHH1?.ansatzPJfort_soll ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

            if (data.jahre.findIndex(d => d == this.props.jahr) >= 0 && totalSum.ergebnisPJ_haben != null && totalSum.ergebnisPJ_soll != null && totalSum.ergebnisPJ_soll != 0 && data.ergebnisPJ_haben != null && data.ergebnisPJ_soll != null && data.ergebnisPJ_soll != 0 && totalHaben != null && totalHaben.ergebnisPJ_haben != null && totalHaben.ergebnisPJ_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJ_haben != undefined ? totalSub.ergebnisPJ_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJ_soll != undefined ? totalSub.ergebnisPJ_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.ergebnisPJ_haben != undefined ? totalHabenSub.ergebnisPJ_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnJR("ergebnisPJ_soll", this.props.jahr, totalSum.ergebnisPJ_soll - subsoll, this.vwHH1?.ergebnisPJ_soll ?? 0, id, "Ergebnis", true));
                    else
                        columns.push(this.createDataColumnJR("ergebnisPJ_soll", this.props.jahr, totalSum.ergebnisPJ_soll - subsoll, undefined, id, "Ergebnis", true));
                else
                    columns.push(this.createDataColumnJR("ergebnisPJ_soll", this.props.jahr, totalSum.ergebnisPJ_soll - subsoll, totalHaben.ergebnisPJ_haben - totalSum.ergebnisPJ_soll - subErgebnis + subsoll, id, "Ergebnis", true));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJ_soll", sumPrev, totalSum.ergebnisPJ_soll - subsoll, true, id, totalSum.id, true, "fortgeschriebenen Ansatz", false, true, sumGPrev, this.vwHH1?.ergebnisPJ_soll ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJ_soll", sumPrev, totalSum.ergebnisPJ_soll - subsoll, true, id, totalSum.id, true, "fortgeschriebenen Ansatz", false, true));
                    id++;
                }
                fieldPrev = "ergebnisPJ_soll";
                sumPrev = totalSum.ergebnisPJ_soll - subsoll;
                sumGPrev = this.vwHH1?.ergebnisPJ_soll ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

        }
        else {
            var fieldPrev: string | undefined;
            var sumPrev = 0;
            var sumGPrev = 0;

            if (data.jahre.findIndex(d => d == this.props.jahr - 4) >= 0 && totalSum.ergebnisPJM4_haben != null && totalSum.ergebnisPJM4_haben != 0) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM4_haben != undefined ? totalSub.ergebnisPJM4_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnJR("ergebnisPJM4_haben", this.props.jahr - 4, totalSum.ergebnisPJM4_haben - subhaben, this.vwHH1?.ergebnisPJM4_haben ?? 0, id, "Ergebnis"));
                    else
                        columns.push(this.createDataColumnJR("ergebnisPJM4_haben", this.props.jahr - 4, totalSum.ergebnisPJM4_haben - subhaben, undefined, id, "Ergebnis"));
                else
                    columns.push(this.createDataColumnJR("ergebnisPJM4_haben", this.props.jahr - 4, totalSum.ergebnisPJM4_haben - subhaben, undefined, id, "Ergebnis"));
                id++;
                if (fieldPrev && id > 3) {
                    columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM4_haben", sumPrev, totalSum.ergebnisPJM4_haben - subhaben, false, id, totalSum.id, true));
                    id++;
                }
                fieldPrev = "ergebnisPJM4_haben";
                sumPrev = totalSum.ergebnisPJM4_haben - subhaben;
                sumGPrev = this.vwHH1?.ergebnisPJM4_haben ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

            if (data.jahre.findIndex(d => d == this.props.jahr - 3) >= 0 && totalSum.ergebnisPJM3_haben != null && totalSum.ergebnisPJM3_haben != 0) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM3_haben != undefined ? totalSub.ergebnisPJM3_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnJR("ergebnisPJM3_haben", this.props.jahr - 3, totalSum.ergebnisPJM3_haben - subhaben, this.vwHH1?.ergebnisPJM3_haben ?? 0, id, "Ergebnis"));
                    else
                        columns.push(this.createDataColumnJR("ergebnisPJM3_haben", this.props.jahr - 3, totalSum.ergebnisPJM3_haben - subhaben, undefined, id, "Ergebnis"));
                else
                    columns.push(this.createDataColumnJR("ergebnisPJM3_haben", this.props.jahr - 3, totalSum.ergebnisPJM3_haben - subhaben, undefined, id, "Ergebnis"));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM3_haben", sumPrev, totalSum.ergebnisPJM3_haben - subhaben, false, id, totalSum.id, true, "Vorjahr", false, false, sumGPrev, this.vwHH1?.ergebnisPJM3_haben ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM3_haben", sumPrev, totalSum.ergebnisPJM3_haben - subhaben, false, id, totalSum.id, true));
                    id++;
                }
                fieldPrev = "ergebnisPJM3_haben";
                sumPrev = totalSum.ergebnisPJM3_haben - subhaben;
                sumGPrev = this.vwHH1?.ergebnisPJM3_haben ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

            if (data.jahre.findIndex(d => d == this.props.jahr - 2) >= 0 && totalSum.ergebnisPJM2_haben != null && totalSum.ergebnisPJM2_haben != 0) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM2_haben != undefined ? totalSub.ergebnisPJM2_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnJR("ergebnisPJM2_haben", this.props.jahr - 2, totalSum.ergebnisPJM2_haben - subhaben, this.vwHH1?.ergebnisPJM2_haben ?? 0, id, "Ergebnis"));
                    else
                        columns.push(this.createDataColumnJR("ergebnisPJM2_haben", this.props.jahr - 2, totalSum.ergebnisPJM2_haben - subhaben, undefined, id, "Ergebnis"));
                else
                    columns.push(this.createDataColumnJR("ergebnisPJM2_haben", this.props.jahr - 2, totalSum.ergebnisPJM2_haben - subhaben, undefined, id, "Ergebnis"));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM2_haben", sumPrev, totalSum.ergebnisPJM2_haben - subhaben, false, id, totalSum.id, true, "Vorjahr", false, false, sumGPrev, this.vwHH1?.ergebnisPJM2_haben ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM2_haben", sumPrev, totalSum.ergebnisPJM2_haben - subhaben, false, id, totalSum.id, true));
                    id++;
                }
                fieldPrev = "ergebnisPJM2_haben";
                sumPrev = totalSum.ergebnisPJM2_haben - subhaben;
                sumGPrev = this.vwHH1?.ergebnisPJM2_haben ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

            if (data.jahre.findIndex(d => d == this.props.jahr - 1) >= 0 && totalSum.ergebnisPJM1_haben != null && totalSum.ergebnisPJM1_haben != 0) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM1_haben != undefined ? totalSub.ergebnisPJM1_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnJR("ergebnisPJM1_haben", this.props.jahr - 1, totalSum.ergebnisPJM1_haben - subhaben, this.vwHH1?.ergebnisPJM1_haben ?? 0, id, "Ergebnis"));
                    else
                        columns.push(this.createDataColumnJR("ergebnisPJM1_haben", this.props.jahr - 1, totalSum.ergebnisPJM1_haben - subhaben, undefined, id, "Ergebnis"));
                else
                    columns.push(this.createDataColumnJR("ergebnisPJM1_haben", this.props.jahr - 1, totalSum.ergebnisPJM1_haben - subhaben, undefined, id, "Ergebnis"));
                id++;
                if (fieldPrev && id > 3) {     
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM1_haben", sumPrev, totalSum.ergebnisPJM1_haben - subhaben, false, id, totalSum.id, true, "Vorjahr", false, false, sumGPrev, this.vwHH1?.ergebnisPJM1_haben ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM1_haben", sumPrev, totalSum.ergebnisPJM1_haben - subhaben, false, id, totalSum.id, true));
                    id++;
                }
                fieldPrev = "ergebnisPJM1_haben";
                sumPrev = totalSum.ergebnisPJM1_haben - subhaben;
                sumGPrev = this.vwHH1?.ergebnisPJM1_haben ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

            if (data.jahre.findIndex(d => d == this.props.jahr) >= 0 && totalSum.ansatzPJfort_haben != null && totalSum.ansatzPJfort_haben != 0) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ansatzPJfort_haben != undefined ? totalSub.ansatzPJfort_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnJR("ansatzPJfort_haben", this.props.jahr, totalSum.ansatzPJfort_haben - subhaben, this.vwHH1?.ansatzPJfort_haben ?? 0, id, "Fortgeschriebener Ansatz", false, true));
                    else
                        columns.push(this.createDataColumnJR("ansatzPJfort_haben", this.props.jahr, totalSum.ansatzPJfort_haben - subhaben, undefined, id, "Fortgeschriebener Ansatz", false, true));
                else
                    columns.push(this.createDataColumnJR("ansatzPJfort_haben", this.props.jahr, totalSum.ansatzPJfort_haben - subhaben, undefined, id, "Fortgeschriebener Ansatz", false, true));
                id++;
                fieldPrev = "ansatzPJfort_haben";
                sumPrev = totalSum.ansatzPJfort_haben - subhaben;
                sumGPrev = this.vwHH1?.ansatzPJfort_haben ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

            if (data.jahre.findIndex(d => d == this.props.jahr) >= 0 && totalSum.ergebnisPJ_haben != null && totalSum.ergebnisPJ_haben != 0) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJ_haben != undefined ? totalSub.ergebnisPJ_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnJR("ergebnisPJ_haben", this.props.jahr, totalSum.ergebnisPJ_haben - subhaben, this.vwHH1?.ergebnisPJ_haben ?? 0, id, "Ergebnis", true));
                    else
                        columns.push(this.createDataColumnJR("ergebnisPJ_haben", this.props.jahr, totalSum.ergebnisPJ_haben - subhaben, undefined, id, "Ergebnis", true));
                else
                    columns.push(this.createDataColumnJR("ergebnisPJ_haben", this.props.jahr, totalSum.ergebnisPJ_haben - subhaben, undefined, id, "Ergebnis", true));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJ_haben", sumPrev, totalSum.ergebnisPJ_haben - subhaben, false, id, totalSum.id, true, "fortgeschriebenen Ansatz", false, true, sumGPrev, this.vwHH1?.ergebnisPJ_haben ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJ_haben", sumPrev, totalSum.ergebnisPJ_haben - subhaben, false, id, totalSum.id, true, "fortgeschriebenen Ansatz", false, true));
                    id++;
                }
                fieldPrev = "ergebnisPJ_haben";
                sumPrev = totalSum.ergebnisPJ_haben - subhaben;
                sumGPrev = this.vwHH1?.ergebnisPJ_haben ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

        }

        if (this.props.settings.jrvjAus) {
            if (ausgaben)
                return Utilities.getCollapsibleColumns(columns, this.state.collapsedColumnsA, this.toggleColumnCollapse, ["ergebnisPJM1_soll", "ergebnisPJM2_soll", "ergebnisPJM3_soll", "ergebnisPJM4_soll"]);
            else
                return Utilities.getCollapsibleColumns(columns, this.state.collapsedColumnsE, this.toggleColumnCollapse, ["ergebnisPJM1_haben", "ergebnisPJM2_haben", "ergebnisPJM3_haben", "ergebnisPJM4_haben"]);
        }

        return columns;
    }

    toggleColumnCollapse = (dataField: string, colIndex: number) => {
        var newA = Utilities.toggleColumnCollapse(this.state.collapsedColumnsA, dataField.replace("haben", "soll"), colIndex);
        var newB = Utilities.toggleColumnCollapse(this.state.collapsedColumnsE, dataField.replace("soll", "haben"), colIndex);
        newA = Utilities.toggleColumnCollapse(newA, "dummy" + (colIndex + 2).toString(), colIndex + 1)
        newB = Utilities.toggleColumnCollapse(newB, "dummy" + (colIndex + 2).toString(), colIndex + 1)

        this.setState((prev: State) => ({            
            collapsedColumnsA: newA,
            collapsedColumnsE: newB
        }));

        
    }


    createColumnsUH = (data: KSLPlusAPI.HaushaltsEbene | null, totalSum: KSLPlusAPI.HaushaltsEbene, totalSub: KSLPlusAPI.HaushaltsEbene | null | undefined, totalHaben: KSLPlusAPI.HaushaltsEbene | null, totalHabenSub: KSLPlusAPI.HaushaltsEbene | null, ausgaben: boolean, gesamtHH: boolean = false, gesamtVWHH: boolean = false) => {
        var columns = [];
        columns.push({
            dataField: 'bezeichnung',
            text: (gesamtHH ? (gesamtVWHH ? "VWHH " : "VMHH ") : "") + (ausgaben ? "Ausgaben/Bezeichnung" : "Einnahmen" + "/Bezeichnung"),            
            headerStyle: (colum: any, colIndex: any) => {
                return { width: (gesamtHH ? "240px" : "180px"), textAlign: 'left' };
            },

            style: (colum: any, colIndex: any) => {
                return { width: (gesamtHH ? "240px" : "180px") };
            },
            footer: "1",
            footerFormatter: (column: any, columnIndex: any) => {
                if (gesamtHH) {
                    if (ausgaben) {
                        if (!gesamtVWHH)
                            return (<div><div>VMHH Ausgaben gesamt</div><div>VWHH und VMHH Ausgaben gesamt</div></div>);

                        return (<div>VWHH Ausgaben gesamt</div>);
                    }


                    if (!gesamtVWHH)
                        return (<div><div>VMHH Einnahmen gesamt</div><div>VWHH und VMHH Einnahmen gesamt</div></div>);

                    return (<div>VWHH Einnahmen gesamt</div>);
                }


                if (ausgaben)
                    return (<div><div>Ausgaben gesamt</div><div>Ergebnis E-A</div></div>);

                return <div>Einnahmen gesamt</div>;
            }
        });




        if (data == null)
            return columns;


        if (!data.jahre)
            return columns;

        if (data.jahre.findIndex(d => d == this.props.jahr - 3) != -1 || data.jahre.findIndex(d => d == this.props.jahr - 4) != -1) {
            columns.push({
                dataField: '',
                isDummyField: true,
                headerAlign: 'middle',
                headerFormatter: (column: any, columnIndex: any) => {
                    var ttId = "kslplus-tt-pjcol" + (ausgaben ? "a" : "e");
                    return (<div>
                        <div id={ttId} className="kslplus-jahre-toggle">{this.state.alleJahre ? "-" : "+"}</div >
                        <UncontrolledPopover
                            placement="right"
                            target={ttId}
                            trigger="hover"
                            className="kslplus-header-popover">
                            <PopoverBody className="kslplus-header-popover-body">
                                <Container>
                                    <div>
                                        {"Zusätzliche Jahre " + (this.state.alleJahre ? "verbergen" : "anzeigen")}
                                    </div>
                                </Container>
                            </PopoverBody>
                        </UncontrolledPopover>
                    </div >);

                },
                text: this.state.alleJahre ? "-" : "+",
                headerStyle: (colum: any, colIndex: any) => {
                    return { fontWeight: 900, width: '30px', textAlign: 'left' };
                },

                style: (colum: any, colIndex: any) => {
                    return { width: '30px' };
                },
                footer: -1,
                headerEvents: {
                    onClick: (e: any, column: any, columnIndex: any) => { this.setState({ alleJahre: !this.state.alleJahre }) }
                }
            });
        }

        var id = 2;
        if (ausgaben) {

            var fieldPrev: string | undefined;
            var sumPrev = 0;
            var sumGPrev = 0;


            if (data.jahre.findIndex(d => d == this.props.jahr - 4) >= 0 && totalSum.ergebnisPJM4_haben != null && totalSum.ergebnisPJM4_soll != null && totalSum.ergebnisPJM4_soll != 0 && data.ergebnisPJM4_haben != null && data.ergebnisPJM4_soll != null && data.ergebnisPJM4_soll != 0 && totalHaben != null && totalHaben.ergebnisPJM4_haben != null && totalHaben.ergebnisPJM4_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM4_haben != undefined ? totalSub.ergebnisPJM4_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM4_soll != undefined ? totalSub.ergebnisPJM4_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.ergebnisPJM4_haben != undefined ? totalHabenSub.ergebnisPJM4_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnUH("ergebnisPJM4_soll", this.props.jahr - 4, totalSum.ergebnisPJM4_soll - subsoll, this.vwHH1?.ergebnisPJM4_soll ?? 0, id, "Ergebnis", !this.state.alleJahre));
                    else
                        columns.push(this.createDataColumnUH("ergebnisPJM4_soll", this.props.jahr - 4, totalSum.ergebnisPJM4_soll - subsoll, undefined, id, "Ergebnis", !this.state.alleJahre));
                else
                    columns.push(this.createDataColumnUH("ergebnisPJM4_soll", this.props.jahr - 4, totalSum.ergebnisPJM4_soll - subsoll, totalHaben.ergebnisPJM4_haben - totalSum.ergebnisPJM4_soll - subErgebnis + subsoll, id, "Ergebnis", !this.state.alleJahre));
                id++;
                /*
                if (fieldPrev && id > 3) {
                    columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM4_soll", sumPrev, totalSum.ergebnisPJM4_soll - subsoll, true, id, totalSum.id, true));
                    id++;
                }
                */
                fieldPrev = "ergebnisPJM4_soll";
                //sumPrev = totalSum.ergebnisPJM4_soll - subsoll;
            }
            else {
                fieldPrev = undefined;
            }


            if (data.jahre.findIndex(d => d == this.props.jahr - 3) >= 0 && totalSum.ergebnisPJM3_haben != null && totalSum.ergebnisPJM3_soll != null && totalSum.ergebnisPJM3_soll != 0 && data.ergebnisPJM3_haben != null && data.ergebnisPJM3_soll != null && data.ergebnisPJM3_soll != 0 && totalHaben != null && totalHaben.ergebnisPJM3_haben != null && totalHaben.ergebnisPJM3_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM3_haben != undefined ? totalSub.ergebnisPJM3_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM3_soll != undefined ? totalSub.ergebnisPJM3_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.ergebnisPJM3_haben != undefined ? totalHabenSub.ergebnisPJM3_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnUH("ergebnisPJM3_soll", this.props.jahr - 3, totalSum.ergebnisPJM3_soll - subsoll, this.vwHH1?.ergebnisPJM3_soll ?? 0, id, "Ergebnis", !this.state.alleJahre));
                    else
                        columns.push(this.createDataColumnUH("ergebnisPJM3_soll", this.props.jahr - 3, totalSum.ergebnisPJM3_soll - subsoll, undefined, id, "Ergebnis", !this.state.alleJahre));
                else
                    columns.push(this.createDataColumnUH("ergebnisPJM3_soll", this.props.jahr - 3, totalSum.ergebnisPJM3_soll - subsoll, totalHaben.ergebnisPJM3_haben - totalSum.ergebnisPJM3_soll - subErgebnis + subsoll, id, "Ergebnis", !this.state.alleJahre));
                id++;
                /*
                if (fieldPrev && id > 3) {
                    columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM3_soll", sumPrev, totalSum.ergebnisPJM3_soll - subsoll, true, id, totalSum.id, true));
                    id++;
                }
                */
                fieldPrev = "ergebnisPJM3_soll";
                //sumPrev = totalSum.ergebnisPJM3_soll - subsoll;
            }
            else {
                fieldPrev = undefined;
            }


            if (data.jahre.findIndex(d => d == this.props.jahr - 2) >= 0 && totalSum.ergebnisPJM2_haben != null && totalSum.ergebnisPJM2_soll != null && totalSum.ergebnisPJM2_soll != 0 && data.ergebnisPJM2_haben != null && data.ergebnisPJM2_soll != null && data.ergebnisPJM2_soll != 0 && totalHaben != null && totalHaben.ergebnisPJM2_haben != null && totalHaben.ergebnisPJM2_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM2_haben != undefined ? totalSub.ergebnisPJM2_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM2_soll != undefined ? totalSub.ergebnisPJM2_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.ergebnisPJM2_haben != undefined ? totalHabenSub.ergebnisPJM2_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnUH("ergebnisPJM2_soll", this.props.jahr - 2, totalSum.ergebnisPJM2_soll - subsoll, this.vwHH1?.ergebnisPJM2_soll ?? 0, id, "Ergebnis"));
                    else
                        columns.push(this.createDataColumnUH("ergebnisPJM2_soll", this.props.jahr - 2, totalSum.ergebnisPJM2_soll - subsoll, undefined, id, "Ergebnis"));
                else
                    columns.push(this.createDataColumnUH("ergebnisPJM2_soll", this.props.jahr - 2, totalSum.ergebnisPJM2_soll - subsoll, totalHaben.ergebnisPJM2_haben - totalSum.ergebnisPJM2_soll - subErgebnis + subsoll, id, "Ergebnis"));
                id++;
                /*
                if (fieldPrev && id > 3) {
                    columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM2_soll", sumPrev, totalSum.ergebnisPJM2_soll - subsoll, true, id, totalSum.id, true));
                    id++;
                }
                */
                fieldPrev = "ergebnisPJM2_soll";
                //sumPrev = totalSum.ergebnisPJM2_soll - subsoll;
            }
            else {
                fieldPrev = undefined;
            }

            if (data.jahre.findIndex(d => d == this.props.jahr - 1) >= 0 && totalSum.ergebnisPJM1_haben != null && totalSum.ergebnisPJM1_soll != null && totalSum.ergebnisPJM1_soll != 0 && data.ergebnisPJM1_haben != null && data.ergebnisPJM1_soll != null && data.ergebnisPJM1_soll != 0 && totalHaben != null && totalHaben.ergebnisPJM1_haben != null && totalHaben.ergebnisPJM1_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM1_haben != undefined ? totalSub.ergebnisPJM1_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM1_soll != undefined ? totalSub.ergebnisPJM1_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.ergebnisPJM1_haben != undefined ? totalHabenSub.ergebnisPJM1_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnUH("ergebnisPJM1_soll", this.props.jahr - 1, totalSum.ergebnisPJM1_soll - subsoll, this.vwHH1?.ergebnisPJM1_soll ?? 0, id, "Ergebnis"));
                    else
                        columns.push(this.createDataColumnUH("ergebnisPJM1_soll", this.props.jahr - 1, totalSum.ergebnisPJM1_soll - subsoll, undefined, id, "Ergebnis"));
                else
                    columns.push(this.createDataColumnUH("ergebnisPJM1_soll", this.props.jahr - 1, totalSum.ergebnisPJM1_soll - subsoll, totalHaben.ergebnisPJM1_haben - totalSum.ergebnisPJM1_soll - subErgebnis + subsoll, id, "Ergebnis"));
                id++;
                /*
                if (fieldPrev && id > 3) {
                    columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM1_soll", sumPrev, totalSum.ergebnisPJM1_soll - subsoll, true, id, totalSum.id, true));
                    id++;
                }
                */
                fieldPrev = "ergebnisPJM1_soll";
                //sumPrev = totalSum.ergebnisPJM1_soll - subsoll;
            }
            else {
                fieldPrev = undefined;
            }

            if (data.jahre.findIndex(d => d == this.props.jahr) >= 0 && totalSum.ansatzPJfort_haben != null && totalSum.ansatzPJfort_soll != null && data.ansatzPJfort_haben != null && data.ansatzPJfort_soll != null && data.ansatzPJfort_soll != 0 && totalHaben != null && totalHaben.ansatzPJfort_haben != null && totalHaben.ansatzPJfort_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ansatzPJfort_haben != undefined ? totalSub.ansatzPJfort_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.ansatzPJfort_soll != undefined ? totalSub.ansatzPJfort_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.ansatzPJfort_haben != undefined ? totalHabenSub.ansatzPJfort_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnUH("ansatzPJfort_soll", this.props.jahr, totalSum.ansatzPJfort_soll - subsoll, this.vwHH1?.ansatzPJfort_soll ?? 0, id, "Fortgeschr. Ansatz", false, false, false, "", "", false, true, false, true));
                    else
                        columns.push(this.createDataColumnUH("ansatzPJfort_soll", this.props.jahr, totalSum.ansatzPJfort_soll - subsoll, undefined, id, "Fortgeschr. Ansatz", false, false, false, "", "", false, true, false, true));
                else
                    columns.push(this.createDataColumnUH("ansatzPJfort_soll", this.props.jahr, totalSum.ansatzPJfort_soll - subsoll, totalHaben.ansatzPJfort_haben - totalSum.ansatzPJfort_soll - subErgebnis + subsoll, id, "Fortgeschr. Ansatz", false, false, false, "", "", false, true, false, true));
                id++;

                fieldPrev = "ansatzPJfort_soll";
                sumPrev = totalSum.ansatzPJfort_soll - subsoll;
                sumGPrev = this.vwHH1?.ansatzPJfort_soll ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

            if (data.jahre.findIndex(d => d == this.props.jahr) >= 0 && totalSum.verfuegt_haben != null && totalSum.verfuegt_soll != null && data.verfuegt_haben != null && data.verfuegt_soll != null && totalHaben != null && totalHaben.verfuegt_haben != null && totalHaben.verfuegt_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.verfuegt_haben != undefined ? totalSub.verfuegt_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.verfuegt_soll != undefined ? totalSub.verfuegt_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.verfuegt_haben != undefined ? totalHabenSub.verfuegt_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnUH("verfuegt_soll", this.props.jahr, totalSum.verfuegt_soll - subsoll, this.vwHH1?.verfuegt_soll ?? 0, id, "Ausgeführt", false, false, false, "", "", false, false, true, true));
                    else
                        columns.push(this.createDataColumnUH("verfuegt_soll", this.props.jahr, totalSum.verfuegt_soll - subsoll, undefined, id, "Ausgeführt", false, false, false, "", "", false, false, true, true));
                else
                    columns.push(this.createDataColumnUH("verfuegt_soll", this.props.jahr, totalSum.verfuegt_soll - subsoll, totalHaben.verfuegt_haben - totalSum.verfuegt_soll - subErgebnis + subsoll, id, "Ausgeführt", false, false, false, "", "", false, false, true, true));
                id++;

                fieldPrev = "verfuegt_soll";
                //sumPrev = totalSum.verfuegt_soll - subsoll;
                if (gesamtHH && !gesamtVWHH)
                    columns.push(this.createDataPercentColumn("verfuegt_soll", "ansatzPJfort_soll", this.props.jahr, id, "Ausgeführt", this.state.alleJahre, false, false, totalSum.verfuegt_soll - subsoll, sumPrev, this.vwHH1?.verfuegt_soll ?? 0, sumGPrev));
                else
                    columns.push(this.createDataPercentColumn("verfuegt_soll", "ansatzPJfort_soll", this.props.jahr, id, "Ausgeführt", this.state.alleJahre, false, false, totalSum.verfuegt_soll - subsoll, sumPrev));
                id++;
                fieldPrev = undefined;
            }
            else {
                fieldPrev = undefined;
            }

            /*
            if (data.jahre.findIndex(d => d == this.props.jahr) >= 0) {
                columns.push(this.createDataPercentColumn("verfuegt_soll", "ansatzPJfort_soll", this.props.jahr, id, "Ausgeführt", false, false));
                id++;
                fieldPrev = undefined;

            }
            else {
                fieldPrev = undefined;
            }
            */

            if (!this.props.settings.keinVerfuegbarEinz && data.jahre.findIndex(d => d == this.props.jahr) >= 0 && totalSum.verfuegbar_haben != null && totalSum.verfuegbar_soll != null && data.verfuegbar_haben != null && data.verfuegbar_soll != null && data.verfuegbar_soll != 0 && totalHaben != null && totalHaben.verfuegbar_haben != null && totalHaben.verfuegbar_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.verfuegbar_haben != undefined ? totalSub.verfuegbar_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.verfuegbar_soll != undefined ? totalSub.verfuegbar_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.verfuegbar_haben != undefined ? totalHabenSub.verfuegbar_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnUH("verfuegbar_soll", this.props.jahr, totalSum.verfuegbar_soll - subsoll, this.vwHH1?.verfuegbar_soll ?? 0, id, "Verfügbar", false, false, false));
                    else
                        columns.push(this.createDataColumnUH("verfuegbar_soll", this.props.jahr, totalSum.verfuegbar_soll - subsoll, undefined, id, "Verfügbar", false, false, false));
                else
                    columns.push(this.createDataColumnUH("verfuegbar_soll", this.props.jahr, totalSum.verfuegbar_soll - subsoll, totalHaben.verfuegbar_haben - totalSum.verfuegbar_soll - subErgebnis + subsoll, id, "Verfügbar", false, false, false));
                id++;

                fieldPrev = "verfuegbar_soll";
                //sumPrev = totalSum.verfuegbar_soll - subsoll;
                if (gesamtHH && !gesamtVWHH)
                    columns.push(this.createDataPercentColumn("verfuegbar_soll", "ansatzPJfort_soll", this.props.jahr, id, "Verfügbar", this.state.alleJahre, false, false, totalSum.verfuegbar_soll - subsoll, sumPrev, this.vwHH1?.verfuegbar_soll ?? 0, sumGPrev));
                else
                    columns.push(this.createDataPercentColumn("verfuegbar_soll", "ansatzPJfort_soll", this.props.jahr, id, "Verfügbar", this.state.alleJahre, false, false, totalSum.verfuegbar_soll - subsoll, sumPrev));
                id++;
                fieldPrev = undefined;
            }
            else {
                fieldPrev = undefined;
            }

            /*
            if (data.jahre.findIndex(d => d == this.props.jahr) >= 0) {
                columns.push(this.createDataPercentColumn("verfuegbar_soll", "ansatzPJfort_soll", this.props.jahr, id, "Einzunehmen / Verfügbar", false, false));
                id++;
                fieldPrev = undefined;

            }
            else {
                fieldPrev = undefined;
            }
            */

            if (!this.props.settings.keinePrognose && !this.props.settings.keinePrognoseErrechnet && data.jahre.findIndex(d => d == this.props.jahr) >= 0 && totalSum.progAuto_haben != null && totalSum.progAuto_soll != null && data.progAuto_haben != null && data.progAuto_soll != null && totalHaben != null && totalHaben.progAuto_haben != null && totalHaben.progAuto_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.progAuto_haben != undefined ? totalSub.progAuto_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.progAuto_soll != undefined ? totalSub.progAuto_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.progAuto_haben != undefined ? totalHabenSub.progAuto_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnUH("progAuto_soll", this.props.jahr, totalSum.progAuto_soll - subsoll, this.vwHH1?.progAuto_soll ?? 0, id, "Prognose errechnet", false, false, false));
                    else
                        columns.push(this.createDataColumnUH("progAuto_soll", this.props.jahr, totalSum.progAuto_soll - subsoll, undefined, id, "Prognose errechnet", false, false, false));
                else
                    columns.push(this.createDataColumnUH("progAuto_soll", this.props.jahr, totalSum.progAuto_soll - subsoll, totalHaben.progAuto_haben - totalSum.progAuto_soll - subErgebnis + subsoll, id, "Prognose errechnet", false, false, false));
                id++;

                fieldPrev = "progAuto_soll";
                //sumPrev = totalSum.progAuto_soll - subsoll;
                if (gesamtHH && !gesamtVWHH)
                    columns.push(this.createChangeColumn("ansatzPJfort_soll", "progAuto_soll", sumPrev, totalSum.progAuto_soll - subsoll, true, id, totalSum.id, true, "fortgeschr. Ansatz", false, false, sumGPrev, this.vwHH1?.progAuto_soll ?? 0));
                else 
                    columns.push(this.createChangeColumn("ansatzPJfort_soll", "progAuto_soll", sumPrev, totalSum.progAuto_soll - subsoll, true, id, totalSum.id, true, "fortgeschr. Ansatz"));

                id++;

            }
            else {
                fieldPrev = undefined;
            }

            if (!this.props.settings.keinePrognose && data.jahre.findIndex(d => d == this.props.jahr) >= 0 && totalSum.progMan_haben != null && totalSum.progMan_soll != null && data.progMan_haben != null && data.progMan_soll != null && totalHaben != null && totalHaben.progMan_haben != null && totalHaben.progMan_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.progMan_haben != undefined ? totalSub.progMan_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.progMan_soll != undefined ? totalSub.progMan_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.progMan_haben != undefined ? totalHabenSub.progMan_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnUH("progMan_soll", this.props.jahr, totalSum.progMan_soll - subsoll, this.vwHH1?.progMan_soll ?? 0, id, this.props.settings.keinePrognoseErrechnet ? "Prognose" : "Prognose manuell", false, false, false, "hasProgMan"));
                    else
                        columns.push(this.createDataColumnUH("progMan_soll", this.props.jahr, totalSum.progMan_soll - subsoll, undefined, id, this.props.settings.keinePrognoseErrechnet ? "Prognose" : "Prognose manuell", false, false, false, "hasProgMan"));
                else
                    columns.push(this.createDataColumnUH("progMan_soll", this.props.jahr, totalSum.progMan_soll - subsoll, totalHaben.progMan_haben - totalSum.progMan_soll - subErgebnis + subsoll, id, this.props.settings.keinePrognoseErrechnet ? "Prognose" : "Prognose manuell", false, false, false, "hasProgMan"));
                id++;

                fieldPrev = "progMan_soll";
                //sumPrev = totalSum.progMan_soll - subsoll;
                if (gesamtHH && !gesamtVWHH)
                    columns.push(this.createChangeColumn("ansatzPJfort_soll", "progMan_soll", sumPrev, totalSum.progMan_soll - subsoll, true, id, totalSum.id, true, "fortgeschr. Ansatz", false, false, sumGPrev, this.vwHH1?.progMan_soll ?? 0));
                else 
                    columns.push(this.createChangeColumn("ansatzPJfort_soll", "progMan_soll", sumPrev, totalSum.progMan_soll - subsoll, true, id, totalSum.id, true, "fortgeschr. Ansatz"));

                id++;

            }
            else {
                fieldPrev = undefined;
            }


            if (data.jahre.findIndex(d => d == this.props.jahr) >= 0 && totalSum.istAo_haben != null && totalSum.istAo_soll != null && totalSum.istAo_soll != 0 && data.istAo_haben != null && data.istAo_soll != null && data.istAo_soll != 0 && totalHaben != null && totalHaben.istAo_haben != null && totalHaben.istAo_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.istAo_haben != undefined ? totalSub.istAo_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.istAo_soll != undefined ? totalSub.istAo_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.istAo_haben != undefined ? totalHabenSub.istAo_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnUH("istAo_soll", this.props.jahr, totalSum.istAo_soll - subsoll, this.vwHH1?.istAo_soll ?? 0, id, "Ist AO", false, false, false));
                    else
                        columns.push(this.createDataColumnUH("istAo_soll", this.props.jahr, totalSum.istAo_soll - subsoll, undefined, id, "Ist AO", false, false, false));
                else
                    columns.push(this.createDataColumnUH("istAo_soll", this.props.jahr, totalSum.istAo_soll - subsoll, totalHaben.istAo_haben - totalSum.istAo_soll - subErgebnis + subsoll, id, "Ist AO", false, false, false));
                id++;

                fieldPrev = "istAo_soll";
                sumPrev = totalSum.istAo_soll - subsoll;
            }
            else {
                fieldPrev = undefined;
            }

        }
        else {
            var fieldPrev: string | undefined;
            var sumPrev = 0;
            var sumGPrev = 0;


            if (data.jahre.findIndex(d => d == this.props.jahr - 4) >= 0 && totalSum.ergebnisPJM4_haben != null && totalSum.ergebnisPJM4_haben != 0) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM4_haben != undefined ? totalSub.ergebnisPJM4_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnUH("ergebnisPJM4_haben", this.props.jahr - 4, totalSum.ergebnisPJM4_haben - subhaben, this.vwHH1?.ergebnisPJM4_haben ?? 0, id, "Ergebnis", !this.state.alleJahre));
                    else
                        columns.push(this.createDataColumnUH("ergebnisPJM4_haben", this.props.jahr - 4, totalSum.ergebnisPJM4_haben - subhaben, undefined, id, "Ergebnis", !this.state.alleJahre));
                else
                    columns.push(this.createDataColumnUH("ergebnisPJM4_haben", this.props.jahr - 4, totalSum.ergebnisPJM4_haben - subhaben, undefined, id, "Ergebnis", !this.state.alleJahre));
                id++;
                /*
                if (fieldPrev && id > 3) {
                    columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM4_haben", sumPrev, totalSum.ergebnisPJM4_haben - subhaben, false, id, totalSum.id, true));
                    id++;
                }
                */
                fieldPrev = "ergebnisPJM4_haben";
                //sumPrev = totalSum.ergebnisPJM4_haben - subhaben;
            }
            else {
                fieldPrev = undefined;
            }

            if (data.jahre.findIndex(d => d == this.props.jahr - 3) >= 0 && totalSum.ergebnisPJM3_haben != null && totalSum.ergebnisPJM3_haben != 0) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM3_haben != undefined ? totalSub.ergebnisPJM3_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnUH("ergebnisPJM3_haben", this.props.jahr - 3, totalSum.ergebnisPJM3_haben - subhaben, this.vwHH1?.ergebnisPJM3_haben ?? 0, id, "Ergebnis", !this.state.alleJahre));
                    else
                        columns.push(this.createDataColumnUH("ergebnisPJM3_haben", this.props.jahr - 3, totalSum.ergebnisPJM3_haben - subhaben, undefined, id, "Ergebnis", !this.state.alleJahre));
                else
                    columns.push(this.createDataColumnUH("ergebnisPJM3_haben", this.props.jahr - 3, totalSum.ergebnisPJM3_haben - subhaben, undefined, id, "Ergebnis", !this.state.alleJahre));
                id++;
                /*
                if (fieldPrev && id > 3) {
                    columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM3_haben", sumPrev, totalSum.ergebnisPJM3_haben - subhaben, false, id, totalSum.id, true));
                    id++;
                }
                */
                fieldPrev = "ergebnisPJM3_haben";
                //sumPrev = totalSum.ergebnisPJM3_haben - subhaben;
            }
            else {
                fieldPrev = undefined;
            }


            if (data.jahre.findIndex(d => d == this.props.jahr - 2) >= 0 && totalSum.ergebnisPJM2_haben != null && totalSum.ergebnisPJM2_haben != 0) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM2_haben != undefined ? totalSub.ergebnisPJM2_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnUH("ergebnisPJM2_haben", this.props.jahr - 2, totalSum.ergebnisPJM2_haben - subhaben, this.vwHH1?.ergebnisPJM2_haben ?? 0, id, "Ergebnis"));
                    else
                        columns.push(this.createDataColumnUH("ergebnisPJM2_haben", this.props.jahr - 2, totalSum.ergebnisPJM2_haben - subhaben, undefined, id, "Ergebnis"));
                else
                    columns.push(this.createDataColumnUH("ergebnisPJM2_haben", this.props.jahr - 2, totalSum.ergebnisPJM2_haben - subhaben, undefined, id, "Ergebnis"));
                id++;
                /*
                if (fieldPrev && id > 3) {
                    columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM2_haben", sumPrev, totalSum.ergebnisPJM2_haben - subhaben, false, id, totalSum.id, true));
                    id++;
                }
                */
                fieldPrev = "ergebnisPJM2_haben";
                //sumPrev = totalSum.ergebnisPJM2_haben - subhaben;
            }
            else {
                fieldPrev = undefined;
            }

            if (data.jahre.findIndex(d => d == this.props.jahr - 1) >= 0 && totalSum.ergebnisPJM1_haben != null && totalSum.ergebnisPJM1_haben != 0) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisPJM1_haben != undefined ? totalSub.ergebnisPJM1_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnUH("ergebnisPJM1_haben", this.props.jahr - 1, totalSum.ergebnisPJM1_haben - subhaben, this.vwHH1?.ergebnisPJM1_haben ?? 0, id, "Ergebnis"));
                    else
                        columns.push(this.createDataColumnUH("ergebnisPJM1_haben", this.props.jahr - 1, totalSum.ergebnisPJM1_haben - subhaben, undefined, id, "Ergebnis"));
                else
                    columns.push(this.createDataColumnUH("ergebnisPJM1_haben", this.props.jahr - 1, totalSum.ergebnisPJM1_haben - subhaben, undefined, id, "Ergebnis"));
                id++;
                /*
                if (fieldPrev && id > 3) {
                    columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM1_haben", sumPrev, totalSum.ergebnisPJM1_haben - subhaben, false, id, totalSum.id, true));
                    id++;
                }
                */
                fieldPrev = "ergebnisPJM1_haben";
                //sumPrev = totalSum.ergebnisPJM1_haben - subhaben;
            }
            else {
                fieldPrev = undefined;
            }

            if (data.jahre.findIndex(d => d == this.props.jahr) >= 0 && totalSum.ansatzPJfort_haben != null ) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ansatzPJfort_haben != undefined ? totalSub.ansatzPJfort_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnUH("ansatzPJfort_haben", this.props.jahr, totalSum.ansatzPJfort_haben - subhaben, this.vwHH1?.ansatzPJfort_haben ?? 0, id, "Fortgeschr. Ansatz", false, false, false, "", "", false, true));
                    else
                        columns.push(this.createDataColumnUH("ansatzPJfort_haben", this.props.jahr, totalSum.ansatzPJfort_haben - subhaben, undefined, id, "Fortgeschr. Ansatz", false, false, false, "", "", false, true));
                else
                    columns.push(this.createDataColumnUH("ansatzPJfort_haben", this.props.jahr, totalSum.ansatzPJfort_haben - subhaben, undefined, id, "Fortgeschr. Ansatz", false, false, false, "", "", false, true));
                id++;
                fieldPrev = "ansatzPJfort_haben";
                sumPrev = totalSum.ansatzPJfort_haben - subhaben;
                sumGPrev = this.vwHH1?.ansatzPJfort_haben ?? 0;
            }
            else {
                fieldPrev = undefined;
            }


            if (data.jahre.findIndex(d => d == this.props.jahr) >= 0 && totalSum.verfuegt_haben != null) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.verfuegt_haben != undefined ? totalSub.verfuegt_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnUH("verfuegt_haben", this.props.jahr, totalSum.verfuegt_haben - subhaben, this.vwHH1?.verfuegt_haben ?? 0, id, "Eingenommen", false, false, false, "", "", false, false, true));
                    else
                        columns.push(this.createDataColumnUH("verfuegt_haben", this.props.jahr, totalSum.verfuegt_haben - subhaben, undefined, id, "Eingenommen", false, false, false, "", "", false, false, true));
                else
                    columns.push(this.createDataColumnUH("verfuegt_haben", this.props.jahr, totalSum.verfuegt_haben - subhaben, undefined, id, "Eingenommen", false, false, false, "", "", false, false, true));
                id++;
                fieldPrev = "verfuegt_haben";
                //sumPrev = totalSum.verfuegt_haben - subhaben;

                if (gesamtHH && !gesamtVWHH)
                    columns.push(this.createDataPercentColumn("verfuegt_haben", "ansatzPJfort_haben", this.props.jahr, id, "Eingenommen", this.state.alleJahre, false, false, totalSum.verfuegt_haben - subhaben, sumPrev, this.vwHH1?.verfuegt_haben ?? 0, sumGPrev));
                else
                    columns.push(this.createDataPercentColumn("verfuegt_haben", "ansatzPJfort_haben", this.props.jahr, id, "Eingenommen", this.state.alleJahre, false, false, totalSum.verfuegt_haben - subhaben, sumPrev));
                id++;
                fieldPrev = undefined;
            }
            else {
                fieldPrev = undefined;
            }

            if (!this.props.settings.keinVerfuegbarEinz && data.jahre.findIndex(d => d == this.props.jahr) >= 0 && totalSum.verfuegbar_haben != null) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.verfuegbar_haben != undefined ? totalSub.verfuegbar_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnUH("verfuegbar_haben", this.props.jahr, totalSum.verfuegbar_haben - subhaben, this.vwHH1?.verfuegbar_haben ?? 0, id, "Einzunehmen", false, false, false));
                    else
                        columns.push(this.createDataColumnUH("verfuegbar_haben", this.props.jahr, totalSum.verfuegbar_haben - subhaben, undefined, id, "Einzunehmen", false, false, false, "", "", false, false, true));
                else
                    columns.push(this.createDataColumnUH("verfuegbar_haben", this.props.jahr, totalSum.verfuegbar_haben - subhaben, undefined, id, "Einzunehmen", false, false, false));
                id++;
                fieldPrev = "verfuegbar_haben";
                //sumPrev = totalSum.verfuegbar_haben - subhaben;

                if (gesamtHH && !gesamtVWHH)
                    columns.push(this.createDataPercentColumn("verfuegbar_haben", "ansatzPJfort_haben", this.props.jahr, id, "Einzunehmen", this.state.alleJahre, false, false, totalSum.verfuegbar_haben - subhaben, sumPrev, this.vwHH1?.verfuegbar_haben ?? 0, sumGPrev));
                else
                    columns.push(this.createDataPercentColumn("verfuegbar_haben", "ansatzPJfort_haben", this.props.jahr, id, "Einzunehmen", this.state.alleJahre, false, false, totalSum.verfuegbar_haben - subhaben, sumPrev));
                id++;
                fieldPrev = undefined;
            }
            else {
                fieldPrev = undefined;
            }

            if (!this.props.settings.keinePrognose && !this.props.settings.keinePrognoseErrechnet && data.jahre.findIndex(d => d == this.props.jahr) >= 0 && totalSum.progAuto_haben != null) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.progAuto_haben != undefined ? totalSub.progAuto_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnUH("progAuto_haben", this.props.jahr, totalSum.progAuto_haben - subhaben, this.vwHH1?.progAuto_haben ?? 0, id, "Prognose errechnet", false, false, false));
                    else
                        columns.push(this.createDataColumnUH("progAuto_haben", this.props.jahr, totalSum.progAuto_haben - subhaben, undefined, id, "Prognose errechnet", false, false, false));
                else
                    columns.push(this.createDataColumnUH("progAuto_haben", this.props.jahr, totalSum.progAuto_haben - subhaben, undefined, id, "Prognose errechnet", false, false, false));
                id++;
                fieldPrev = "progAuto_haben";
                //sumPrev = totalSum.progAuto_haben - subhaben;
                if (gesamtHH && !gesamtVWHH)
                    columns.push(this.createChangeColumn("ansatzPJfort_haben", "progAuto_haben", sumPrev, totalSum.progAuto_haben - subhaben, false, id, totalSum.id, true, "fortgeschr. Ansatz", false, false, sumGPrev, this.vwHH1?.progAuto_haben ?? 0));
                else 
                    columns.push(this.createChangeColumn("ansatzPJfort_haben", "progAuto_haben", sumPrev, totalSum.progAuto_haben - subhaben, false, id, totalSum.id, true, "fortgeschr. Ansatz"));

                id++;
            }
            else {
                fieldPrev = undefined;
            }

            if (!this.props.settings.keinePrognose && data.jahre.findIndex(d => d == this.props.jahr) >= 0 && totalSum.progMan_haben != null) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.progMan_haben != undefined ? totalSub.progMan_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnUH("progMan_haben", this.props.jahr, totalSum.progMan_haben - subhaben, this.vwHH1?.progMan_haben ?? 0, id, this.props.settings.keinePrognoseErrechnet ? "Prognose" : "Prognose manuell", false, false, false, "hasProgMan"));
                    else
                        columns.push(this.createDataColumnUH("progMan_haben", this.props.jahr, totalSum.progMan_haben - subhaben, undefined, id, this.props.settings.keinePrognoseErrechnet ? "Prognose" : "Prognose manuell", false, false, false, "hasProgMan"));
                else
                    columns.push(this.createDataColumnUH("progMan_haben", this.props.jahr, totalSum.progMan_haben - subhaben, undefined, id, this.props.settings.keinePrognoseErrechnet ? "Prognose" : "Prognose manuell", false, false, false, "hasProgMan"));
                id++;
                fieldPrev = "progMan_haben";
                //sumPrev = totalSum.progMan_haben - subhaben;

                if (gesamtHH && !gesamtVWHH)
                    columns.push(this.createChangeColumn("ansatzPJfort_haben", "progMan_haben", sumPrev, totalSum.progMan_haben - subhaben, false, id, totalSum.id, true, "fortgeschr. Ansatz", false, false, sumGPrev, this.vwHH1?.progMan_haben ?? 0));
                else 
                    columns.push(this.createChangeColumn("ansatzPJfort_haben", "progMan_haben", sumPrev, totalSum.progMan_haben - subhaben, false, id, totalSum.id, true, "fortgeschr. Ansatz"));

                id++;
            }
            else {
                fieldPrev = undefined;
            }

            if (data.jahre.findIndex(d => d == this.props.jahr) >= 0 && totalSum.istAo_haben != null && totalSum.istAo_haben != 0) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.istAo_haben != undefined ? totalSub.istAo_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumnUH("istAo_haben", this.props.jahr, totalSum.istAo_haben - subhaben, this.vwHH1?.istAo_haben ?? 0, id, "Ist AO"));
                    else
                        columns.push(this.createDataColumnUH("istAo_haben", this.props.jahr, totalSum.istAo_haben - subhaben, undefined, id, "Ist AO"));
                else
                    columns.push(this.createDataColumnUH("istAo_haben", this.props.jahr, totalSum.istAo_haben - subhaben, undefined, id, "Ist AO"));
                id++;

            }
            else {
                fieldPrev = undefined;
            }

        }
        return columns;
    }


    createColumns = (data: KSLPlusAPI.HaushaltsEbene | null, totalSum: KSLPlusAPI.HaushaltsEbene, totalSub: KSLPlusAPI.HaushaltsEbene | null | undefined, totalHaben: KSLPlusAPI.HaushaltsEbene | null, totalHabenSub: KSLPlusAPI.HaushaltsEbene | null, ausgaben: boolean, gesamtHH: boolean = false, gesamtVWHH: boolean = false) => {
        if (this.props.plantyp == 3)
            return this.createColumnsJR(data, totalSum, totalSub, totalHaben, totalHabenSub, ausgaben, gesamtHH, gesamtVWHH);

        if (this.props.plantyp == 4)
            return this.createColumnsUH(data, totalSum, totalSub, totalHaben, totalHabenSub, ausgaben, gesamtHH, gesamtVWHH);

        var columns = [];
        columns.push({
            dataField: 'bezeichnung',
            text: (gesamtHH ? (gesamtVWHH ? "VWHH " : "VMHH ") : "") + (ausgaben ? "Ausgaben/Bezeichnung" : "Einnahmen" + "/Bezeichnung"),
            headerStyle: (colum: any, colIndex: any) => {
                return { width: (gesamtHH ? "240px" : "180px") , textAlign: 'left' };
            },

            style: (colum: any, colIndex: any) => {
                return { width: (gesamtHH ? "240px" : "180px") };
            },
            footer: "1",
            footerFormatter: (column: any, columnIndex: any) => {
                if (gesamtHH) {
                    if (ausgaben) {
                        if (!gesamtVWHH)
                            return (<div><div>VMHH Ausgaben gesamt</div><div>VWHH und VMHH Ausgaben gesamt</div></div>);

                        return (<div>VWHH Ausgaben gesamt</div>);
                    }
                    

                    if ( !gesamtVWHH )
                        return (<div><div>VMHH Einnahmen gesamt</div><div>VWHH und VMHH Einnahmen gesamt</div></div>);

                    return (<div>VWHH Einnahmen gesamt</div>);
                }

                if (ausgaben)
                    return (<div><div>Ausgaben gesamt</div><div>Ergebnis E-A</div></div>);

                return <div>Einnahmen gesamt</div>;
            }
        });

        if (data == null)
            return columns;

        var id = 2;



        if (!data.jahre)
            return columns;

        if (data.jahre.findIndex(d => d == this.props.jahr - 1) != -1 && this.props.settings.vjErgAnzHp && data.hasVJErg) {
            columns.push({
                dataField: '',
                isDummyField: true,
                headerAlign: 'middle',
                headerFormatter: (column: any, columnIndex: any) => {
                    var ttId = "kslplus-tt-pjcol" + (ausgaben ? "a" : "e");
                    return (<div>
                        <div id={ttId} className="kslplus-jahre-toggle">{this.state.alleJahre ? "-" : "+"}</div >
                        <UncontrolledPopover
                            placement="right"
                            target={ttId}
                            trigger="hover"
                            className="kslplus-header-popover">
                            <PopoverBody className="kslplus-header-popover-body">
                                <Container>
                                    <div>
                                        {"Zusätzliche Jahre " + (this.state.alleJahre ? "verbergen" : "anzeigen")}
                                    </div>
                                </Container>
                            </PopoverBody>
                        </UncontrolledPopover>
                    </div >);

                },
                text: this.state.alleJahre ? "-" : "+",
                headerStyle: (colum: any, colIndex: any) => {
                    return { fontWeight: 900, width: '30px', textAlign: 'left' };
                },

                style: (colum: any, colIndex: any) => {
                    return { width: '30px' };
                },
                footer: -1,
                headerEvents: {
                    onClick: (e: any, column: any, columnIndex: any) => { this.setState({ alleJahre: !this.state.alleJahre }) }
                }
            });
        }


        if (ausgaben) {
            var fieldPrev: string | undefined;
            var sumPrev = 0;
            var sumGPrev = 0;
            
            if (data.jahre.findIndex(d => d == this.props.jahr - 3) >= 0 && totalSum.ergebnisVvvJ_haben != null && totalSum.ergebnisVvvJ_soll != null && data.ergebnisVvvJ_haben != null && data.ergebnisVvvJ_soll != null && totalHaben != null && totalHaben.ergebnisVvvJ_haben != null && totalHaben.ergebnisVvvJ_haben !== undefined) {            
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisVvvJ_haben != undefined ? totalSub.ergebnisVvvJ_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.ergebnisVvvJ_soll != undefined ? totalSub.ergebnisVvvJ_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.ergebnisVvvJ_haben != undefined ? totalHabenSub.ergebnisVvvJ_haben : 0);                
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumn("ergebnisVvvJ_soll", this.props.jahr - 3, totalSum.ergebnisVvvJ_soll - subsoll, this.vwHH1?.ergebnisVvvJ_soll ?? 0, id));
                    else
                        columns.push(this.createDataColumn("ergebnisVvvJ_soll", this.props.jahr - 3, totalSum.ergebnisVvvJ_soll - subsoll, undefined, id));
                else
                    columns.push(this.createDataColumn("ergebnisVvvJ_soll", this.props.jahr - 3, totalSum.ergebnisVvvJ_soll - subsoll, totalHaben.ergebnisVvvJ_haben - totalSum.ergebnisVvvJ_soll - subErgebnis + subsoll, id));
                id++;
                if (fieldPrev && id > 3) {
                    columns.push(this.createChangeColumn(fieldPrev, "ergebnisVvvJ_soll", sumPrev, totalSum.ergebnisVvvJ_soll - subsoll, true, id, totalSum.id, true));
                    id++;
                }
                fieldPrev = "ergebnisVvvJ_soll";
                sumPrev = totalSum.ergebnisVvvJ_soll - subsoll;    
                sumGPrev = this.vwHH1?.ergebnisVvvJ_soll ?? 0;
            }
            else {
                fieldPrev = undefined;
            }
            
            if (data.jahre.findIndex(d => d == this.props.jahr - 2) >= 0 && totalSum.ergebnisVvJ_haben != null && totalSum.ergebnisVvJ_soll != null && data.ergebnisVvJ_haben != null && data.ergebnisVvJ_soll != null && totalHaben != null && totalHaben.ergebnisVvJ_haben != null && totalHaben.ergebnisVvJ_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisVvJ_haben != undefined ? totalSub.ergebnisVvJ_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.ergebnisVvJ_soll != undefined ? totalSub.ergebnisVvJ_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.ergebnisVvJ_haben != undefined ? totalHabenSub.ergebnisVvJ_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumn("ergebnisVvJ_soll", this.props.jahr - 2, totalSum.ergebnisVvJ_soll - subsoll, this.vwHH1?.ergebnisVvJ_soll ?? 0, id));
                    else
                        columns.push(this.createDataColumn("ergebnisVvJ_soll", this.props.jahr - 2, totalSum.ergebnisVvJ_soll - subsoll, undefined, id));
                else
                    columns.push(this.createDataColumn("ergebnisVvJ_soll", this.props.jahr - 2, totalSum.ergebnisVvJ_soll - subsoll, totalHaben.ergebnisVvJ_haben - totalSum.ergebnisVvJ_soll - subErgebnis + subsoll, id));
                id++;
                if (fieldPrev && id > 3) {
                    
                    columns.push(this.createChangeColumn(fieldPrev, "ergebnisVvJ_soll", sumPrev, totalSum.ergebnisVvJ_soll - subsoll, true, id, totalSum.id, true));
                    id++;
                }
                fieldPrev = "ergebnisVvJ_soll";
                sumPrev = totalSum.ergebnisVvJ_soll - subsoll;
                sumGPrev = this.vwHH1?.ergebnisVvJ_soll ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

            if (data.jahre.findIndex(d => d == this.props.jahr - 1) >= 0 && totalSum.ansatzVJ_haben != null && totalSum.ansatzVJ_soll != null && data.ansatzVJ_haben != null && data.ansatzVJ_soll != null && totalHaben != null && totalHaben.ansatzVJ_haben != null && totalHaben.ansatzVJ_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ansatzVJ_haben != undefined ? totalSub.ansatzVJ_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.ansatzVJ_soll != undefined ? totalSub.ansatzVJ_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.ansatzVJ_haben != undefined ? totalHabenSub.ansatzVJ_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumn("ansatzVJ_soll", this.props.jahr - 1, totalSum.ansatzVJ_soll - subsoll, this.vwHH1?.ansatzVJ_soll ?? 0, id));
                    else
                        columns.push(this.createDataColumn("ansatzVJ_soll", this.props.jahr - 1, totalSum.ansatzVJ_soll - subsoll, undefined, id));
                else
                    columns.push(this.createDataColumn("ansatzVJ_soll", this.props.jahr - 1, totalSum.ansatzVJ_soll - subsoll, totalHaben.ansatzVJ_haben - totalSum.ansatzVJ_soll - subErgebnis + subsoll, id));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "ansatzVJ_soll", sumPrev, totalSum.ansatzVJ_soll - subsoll, true, id, totalSum.id, true, "Vorjahr", false, false, sumGPrev, this.vwHH1?.ansatzVJ_soll ?? 0));
                    else
                        columns.push(this.createChangeColumn(fieldPrev, "ansatzVJ_soll", sumPrev, totalSum.ansatzVJ_soll - subsoll, true, id, totalSum.id, true));
                    id++;
                }
                fieldPrev = "ansatzVJ_soll";
                sumPrev = totalSum.ansatzVJ_soll - subsoll;
                sumGPrev = this.vwHH1?.ansatzVJ_soll ?? 0;
            }
            else {
                fieldPrev = undefined;
            }


            if (data.jahre.findIndex(d => d == this.props.jahr - 1) >= 0 && this.state.alleJahre) {
                var subhaben = totalSub?.ergebnisPJM1_haben ?? 0;
                var subsoll = totalSub?.ergebnisPJM1_soll ?? 0;
                var subErgebnis = totalHabenSub?.ergebnisPJM1_haben ?? 0;
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumn("ergebnisPJM1_soll", this.props.jahr - 1, (totalSum?.ergebnisPJM1_soll ?? 0) - subsoll, this.vwHH1?.ergebnisPJM1_soll ?? 0, id));
                    else
                        columns.push(this.createDataColumn("ergebnisPJM1_soll", this.props.jahr - 1, (totalSum?.ergebnisPJM1_soll ?? 0) - subsoll, undefined, id));
                else
                    columns.push(this.createDataColumn("ergebnisPJM1_soll", this.props.jahr - 1, (totalSum?.ergebnisPJM1_soll ?? 0) - subsoll, (totalHaben?.ergebnisPJM1_haben ?? 0) - (totalSum?.ergebnisPJM1_soll ?? 0) - subErgebnis + subsoll, id, this.props.settings.vorjahrVorlaeufig ? "vorl. Ergebnis " : "Ergebnis "));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM1_soll", sumPrev, (totalSum?.ergebnisPJM1_soll ?? 0) - subsoll, true, id, totalSum.id, true, "Ansatz", false, false, sumGPrev, this.vwHH1?.ergebnisPJM1_soll ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM1_soll", sumPrev, (totalSum?.ergebnisPJM1_soll ?? 0) - subsoll, true, id, totalSum.id, true, "Ansatz"));
                    id++;
                }
            }


            if (data.jahre.findIndex(d => d == this.props.jahr) >= 0 && totalSum.ansatzPj_haben != null && totalSum.ansatzPj_soll != null && data.ansatzPj_haben != null && data.ansatzPj_soll != null && totalHaben != null && totalHaben.ansatzPj_haben != null && totalHaben.ansatzPj_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ansatzPj_haben != undefined ? totalSub.ansatzPj_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.ansatzPj_soll != undefined ? totalSub.ansatzPj_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.ansatzPj_haben != undefined ? totalHabenSub.ansatzPj_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumn("ansatzPj_soll", this.props.jahr, totalSum.ansatzPj_soll - subsoll, this.vwHH1?.ansatzPj_soll ?? 0, id));
                    else
                        columns.push(this.createDataColumn("ansatzPj_soll", this.props.jahr, totalSum.ansatzPj_soll - subsoll, undefined, id));
                else
                    columns.push(this.createDataColumn("ansatzPj_soll", this.props.jahr, totalSum.ansatzPj_soll - subsoll, totalHaben.ansatzPj_haben - totalSum.ansatzPj_soll - subErgebnis + subsoll, id));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "ansatzPj_soll", sumPrev, totalSum.ansatzPj_soll - subsoll, true, id, totalSum.id, true, "Vorjahresansatz", true, false, sumGPrev, this.vwHH1?.ansatzPj_soll ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "ansatzPj_soll", sumPrev, totalSum.ansatzPj_soll - subsoll, true, id, totalSum.id, true, "Vorjahresansatz", true));
                    id++;
                }
                fieldPrev = "ansatzPj_soll";
                sumPrev = totalSum.ansatzPj_soll - subsoll;
                sumGPrev = this.vwHH1?.ansatzPj_soll ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

            if (!this.props.settings.doppelhaushalt && data.jahre.findIndex(d => d > this.props.jahr) >= 0) {
                columns.push({
                    dataField: '',
                    isDummyField: true,
                    headerAlign: 'middle',
                    headerFormatter: (column: any, columnIndex: any) => {
                        var ttId = "kslplus-tt-fpcol-vb" + (ausgaben ? "a" : "e");
                        return (<div>
                            <div id={ttId} className="kslplus-jahre-toggle">{this.state.fpJahre ? "-" : "+"}</div >
                            <UncontrolledPopover
                                placement="right"
                                target={ttId}
                                trigger="hover"
                                className="kslplus-header-popover">
                                <PopoverBody className="kslplus-header-popover-body">
                                    <Container>
                                        <div>
                                            {"Finanzplanjahre " + (this.state.fpJahre ? "verbergen" : "anzeigen")}
                                        </div>
                                    </Container>
                                </PopoverBody>
                            </UncontrolledPopover>
                        </div >);

                    },
                    text: this.state.fpJahre ? "-" : "+",
                    headerStyle: (colum: any, colIndex: any) => {
                        return { fontWeight: 900, width: '30px', textAlign: 'left' };
                    },

                    style: (colum: any, colIndex: any) => {
                        return { width: '30px' };
                    },
                    footer: -1,
                    headerEvents: {
                        onClick: (e: any, column: any, columnIndex: any) => { this.setState({ fpJahre: !this.state.fpJahre }) }
                    }
                });
            }

            if ((this.props.settings.doppelhaushalt || this.state.fpJahre) && data.jahre.findIndex(d => d == this.props.jahr + 1) >= 0 && totalSum.fp1_haben != null && totalSum.fp1_soll != null && data.fp1_haben != null && data.fp1_soll != null && totalHaben != null && totalHaben.fp1_haben != null && totalHaben.fp1_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.fp1_haben != undefined ? totalSub.fp1_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.fp1_soll != undefined ? totalSub.fp1_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.fp1_haben != undefined ? totalHabenSub.fp1_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumn("fp1_soll", this.props.jahr + 1, totalSum.fp1_soll - subsoll, this.vwHH1?.fp1_soll ?? 0, id));
                    else
                        columns.push(this.createDataColumn("fp1_soll", this.props.jahr + 1, totalSum.fp1_soll - subsoll, undefined, id));
                else
                    columns.push(this.createDataColumn("fp1_soll", this.props.jahr + 1, totalSum.fp1_soll - subsoll, totalHaben.fp1_haben - totalSum.fp1_soll - subErgebnis + subsoll, id));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "fp1_soll", sumPrev, totalSum.fp1_soll - subsoll, true, id, totalSum.id, true, "Vorjahr", this.props.settings.doppelhaushalt ? true : false, false, sumGPrev, this.vwHH1?.fp1_soll ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "fp1_soll", sumPrev, totalSum.fp1_soll - subsoll, true, id, totalSum.id, true, "Vorjahr", this.props.settings.doppelhaushalt ? true : false));
                    id++;
                }
                fieldPrev = "fp1_soll";
                sumPrev = totalSum.fp1_soll - subsoll;
                sumGPrev = this.vwHH1?.fp1_soll ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

            if (this.props.settings.doppelhaushalt && data.jahre.findIndex(d => d > this.props.jahr) >= 0) {
                columns.push({
                    dataField: '',
                    isDummyField: true,
                    headerAlign: 'middle',
                    headerFormatter: (column: any, columnIndex: any) => {
                        var ttId = "kslplus-tt-fpcol-vb" + (ausgaben ? "a" : "e");
                        return (<div>
                            <div id={ttId} className="kslplus-jahre-toggle">{this.state.fpJahre ? "-" : "+"}</div >
                            <UncontrolledPopover
                                placement="right"
                                target={ttId}
                                trigger="hover"
                                className="kslplus-header-popover">
                                <PopoverBody className="kslplus-header-popover-body">
                                    <Container>
                                        <div>
                                            {"Finanzplanjahre " + (this.state.fpJahre ? "verbergen" : "anzeigen")}
                                        </div>
                                    </Container>
                                </PopoverBody>
                            </UncontrolledPopover>
                        </div >);

                    },
                    text: this.state.fpJahre ? "-" : "+",
                    headerStyle: (colum: any, colIndex: any) => {
                        return { fontWeight: 900, width: '30px', textAlign: 'left' };
                    },

                    style: (colum: any, colIndex: any) => {
                        return { width: '30px' };
                    },
                    footer: -1,
                    headerEvents: {
                        onClick: (e: any, column: any, columnIndex: any) => { this.setState({ fpJahre: !this.state.fpJahre }) }
                    }
                });
            }

            if (this.state.fpJahre && data.jahre.findIndex(d => d == this.props.jahr + 2) >= 0 && totalSum.fp2_haben != null && totalSum.fp2_soll != null && data.fp2_haben != null && data.fp2_soll != null && totalHaben != null && totalHaben.fp2_haben != null && totalHaben.fp2_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.fp2_haben != undefined ? totalSub.fp2_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.fp2_soll != undefined ? totalSub.fp2_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.fp2_haben != undefined ? totalHabenSub.fp2_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumn("fp2_soll", this.props.jahr + 2, totalSum.fp2_soll - subsoll, this.vwHH1?.fp2_soll ?? 0, id));
                    else
                        columns.push(this.createDataColumn("fp2_soll", this.props.jahr + 2, totalSum.fp2_soll - subsoll, undefined, id));
                else
                    columns.push(this.createDataColumn("fp2_soll", this.props.jahr + 2, totalSum.fp2_soll - subsoll, totalHaben.fp2_haben - totalSum.fp2_soll - subErgebnis + subsoll, id));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "fp2_soll", sumPrev, totalSum.fp2_soll - subsoll, true, id, totalSum.id, true, "Vorjahr", false, false, sumGPrev, this.vwHH1?.fp2_soll ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "fp2_soll", sumPrev, totalSum.fp2_soll - subsoll, true, id, totalSum.id, true));
                    id++;
                }
                fieldPrev = "fp2_soll";
                sumPrev = totalSum.fp2_soll - subsoll;
                sumGPrev = this.vwHH1?.fp2_soll ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

            if (this.state.fpJahre && data.jahre.findIndex(d => d == this.props.jahr + 3) >= 0 && totalSum.fp3_haben != null && totalSum.fp3_soll != null && data.fp3_haben != null && data.fp3_soll != null && totalHaben != null && totalHaben.fp3_haben != null && totalHaben.fp3_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.fp3_haben != undefined ? totalSub.fp3_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.fp3_soll != undefined ? totalSub.fp3_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.fp3_haben != undefined ? totalHabenSub.fp3_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumn("fp3_soll", this.props.jahr + 3, totalSum.fp3_soll - subsoll, this.vwHH1?.fp3_soll ?? 0, id));
                    else
                        columns.push(this.createDataColumn("fp3_soll", this.props.jahr + 3, totalSum.fp3_soll - subsoll, undefined, id));
                else
                columns.push(this.createDataColumn("fp3_soll", this.props.jahr + 3, totalSum.fp3_soll - subsoll, totalHaben.fp3_haben - totalSum.fp3_soll - subErgebnis + subsoll, id));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "fp3_soll", sumPrev, totalSum.fp3_soll - subsoll, true, id, totalSum.id, true, "Vorjahr", false, false, sumGPrev, this.vwHH1?.fp3_soll ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "fp3_soll", sumPrev, totalSum.fp3_soll - subsoll, true, id, totalSum.id, true));
                    id++;
                }
                fieldPrev = "fp3_soll";
                sumPrev = totalSum.fp3_soll - subsoll;
                sumGPrev = this.vwHH1?.fp3_soll ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

            if (this.state.fpJahre && data.jahre.findIndex(d => d == this.props.jahr + 4) >= 0 && totalSum.fp4_haben != null && totalSum.fp4_soll != null && data.fp4_haben != null && data.fp4_soll != null && totalHaben != null && totalHaben.fp4_haben != null && totalHaben.fp4_haben !== undefined) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.fp4_haben != undefined ? totalSub.fp4_haben : 0);
                var subsoll = (totalSub != null && totalSub !== undefined && totalSub.fp4_soll != undefined ? totalSub.fp4_soll : 0);
                var subErgebnis = (totalHabenSub != null && totalHabenSub !== undefined && totalHabenSub.fp4_haben != undefined ? totalHabenSub.fp4_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumn("fp4_soll", this.props.jahr + 4, totalSum.fp4_soll - subsoll, this.vwHH1?.fp4_soll ?? 0, id));
                    else
                        columns.push(this.createDataColumn("fp4_soll", this.props.jahr + 4, totalSum.fp4_soll - subsoll, undefined, id));
                else
                    columns.push(this.createDataColumn("fp4_soll", this.props.jahr + 4, totalSum.fp4_soll - subsoll, totalHaben.fp4_haben - totalSum.fp4_soll - subErgebnis + subsoll, id));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "fp4_soll", sumPrev, totalSum.fp4_soll - subsoll, true, id, totalSum.id, true, "Vorjahr", false, false, sumGPrev, this.vwHH1?.fp4_soll ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "fp4_soll", sumPrev, totalSum.fp4_soll - subsoll, true, id, totalSum.id, true));
                    id++;
                }
                fieldPrev = "fp4_soll";
                sumPrev = totalSum.fp4_soll - subsoll;
                sumGPrev = this.vwHH1?.fp4_soll ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

        }
        else {
            var fieldPrev: string | undefined;
            var sumPrev = 0;
            var sumGPrev = 0;

            
            if (data.jahre.findIndex(d => d == this.props.jahr - 3) >= 0 && totalSum.ergebnisVvvJ_haben != null) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisVvvJ_haben != undefined ? totalSub.ergebnisVvvJ_haben : 0);                            
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumn("ergebnisVvvJ_haben", this.props.jahr - 3, totalSum.ergebnisVvvJ_haben - subhaben, this.vwHH1?.ergebnisVvvJ_haben ?? 0, id));
                    else
                        columns.push(this.createDataColumn("ergebnisVvvJ_haben", this.props.jahr - 3, totalSum.ergebnisVvvJ_haben - subhaben, undefined, id));
                else
                    columns.push(this.createDataColumn("ergebnisVvvJ_haben", this.props.jahr - 3, totalSum.ergebnisVvvJ_haben - subhaben, undefined, id));
                id++;
                if (fieldPrev && id > 3) {
                    columns.push(this.createChangeColumn(fieldPrev, "ergebnisVvvJ_haben", sumPrev, totalSum.ergebnisVvvJ_haben - subhaben, false, id, totalSum.id, true));
                    id++;
                }
                fieldPrev = "ergebnisVvvJ_haben";
                sumPrev = totalSum.ergebnisVvvJ_haben - subhaben;
                sumGPrev = this.vwHH1?.ergebnisVvvJ_haben ?? 0;
            }
            else {
                fieldPrev = undefined;
            }
            
            if (data.jahre.findIndex(d => d == this.props.jahr - 2) >= 0 && totalSum.ergebnisVvJ_haben != null) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ergebnisVvJ_haben != undefined ? totalSub.ergebnisVvJ_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumn("ergebnisVvJ_haben", this.props.jahr - 2, totalSum.ergebnisVvJ_haben - subhaben, this.vwHH1?.ergebnisVvJ_haben ?? 0, id));                        
                    else
                        columns.push(this.createDataColumn("ergebnisVvJ_haben", this.props.jahr - 2, totalSum.ergebnisVvJ_haben - subhaben, undefined, id));
                else
                    columns.push(this.createDataColumn("ergebnisVvJ_haben", this.props.jahr - 2, totalSum.ergebnisVvJ_haben - subhaben, undefined, id));
                id++;
                if (fieldPrev && id > 3) {
                    columns.push(this.createChangeColumn(fieldPrev, "ergebnisVvJ_haben", sumPrev, totalSum.ergebnisVvJ_haben - subhaben, false, id, totalSum.id, true));
                    id++;
                }
                fieldPrev = "ergebnisVvJ_haben";
                sumPrev = totalSum.ergebnisVvJ_haben - subhaben;
                sumGPrev = this.vwHH1?.ergebnisVvJ_haben ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

            if (data.jahre.findIndex(d => d == this.props.jahr - 1) >= 0 && totalSum.ansatzVJ_haben != null) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ansatzVJ_haben != undefined ? totalSub.ansatzVJ_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumn("ansatzVJ_haben", this.props.jahr - 1, totalSum.ansatzVJ_haben - subhaben, this.vwHH1?.ansatzVJ_haben ?? 0, id));
                    else
                        columns.push(this.createDataColumn("ansatzVJ_haben", this.props.jahr - 1, totalSum.ansatzVJ_haben - subhaben, undefined, id));
                else
                    columns.push(this.createDataColumn("ansatzVJ_haben", this.props.jahr - 1, totalSum.ansatzVJ_haben - subhaben, undefined, id));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "ansatzVJ_haben", sumPrev, totalSum.ansatzVJ_haben - subhaben, false, id, totalSum.id, true, "Vorjahr", false, false, sumGPrev, this.vwHH1?.ansatzVJ_haben ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "ansatzVJ_haben", sumPrev, totalSum.ansatzVJ_haben - subhaben, false, id, totalSum.id, true));
                    id++;
                }
                fieldPrev = "ansatzVJ_haben";
                sumPrev = totalSum.ansatzVJ_haben - subhaben;
                sumGPrev = this.vwHH1?.ansatzVJ_haben ?? 0;
            }
            else {
                fieldPrev = undefined;
            }


            if (data.jahre.findIndex(d => d == this.props.jahr - 1) >= 0 && this.state.alleJahre) {
                var subhaben = totalSub?.ergebnisPJM1_haben ?? 0;
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumn("ergebnisPJM1_haben", this.props.jahr - 1, (totalSum?.ergebnisPJM1_haben ?? 0) - subhaben, this.vwHH1?.ergebnisPJM1_haben ?? 0, id));
                    else
                        columns.push(this.createDataColumn("ergebnisPJM1_haben", this.props.jahr - 1, (totalSum?.ergebnisPJM1_haben ?? 0) - subhaben, undefined, id));
                else
                    columns.push(this.createDataColumn("ergebnisPJM1_haben", this.props.jahr - 1, (totalSum?.ergebnisPJM1_haben ?? 0) - subhaben, undefined, id, this.props.settings.vorjahrVorlaeufig ? "vorl. Ergebnis " : "Ergebnis "));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM1_haben", sumPrev, (totalSum?.ergebnisPJM1_haben ?? 0) - subhaben, false, id, totalSum.id, true, "Ansatz", false, false, sumGPrev, this.vwHH1?.ergebnisPJM1_haben ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "ergebnisPJM1_haben", sumPrev, (totalSum?.ergebnisPJM1_haben ?? 0) - subhaben, false, id, totalSum.id, true, "Ansatz"));
                    id++;
                }
            }

            if (data.jahre.findIndex(d => d == this.props.jahr) >= 0 && totalSum.ansatzPj_haben != null) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.ansatzPj_haben != undefined ? totalSub.ansatzPj_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumn("ansatzPj_haben", this.props.jahr, totalSum.ansatzPj_haben - subhaben, this.vwHH1?.ansatzPj_haben ?? 0, id));
                    else
                        columns.push(this.createDataColumn("ansatzPj_haben", this.props.jahr, totalSum.ansatzPj_haben - subhaben, undefined, id));
                else
                    columns.push(this.createDataColumn("ansatzPj_haben", this.props.jahr, totalSum.ansatzPj_haben - subhaben, undefined, id));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "ansatzPj_haben", sumPrev, totalSum.ansatzPj_haben - subhaben, false, id, totalSum.id, true, "Vorjahresansatz", true, false, sumGPrev, this.vwHH1?.ansatzPj_haben ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "ansatzPj_haben", sumPrev, totalSum.ansatzPj_haben - subhaben, false, id, totalSum.id, true, "Vorjahresansatz", true));
                    id++;
                }
                fieldPrev = "ansatzPj_haben";
                sumPrev = totalSum.ansatzPj_haben - subhaben;
                sumGPrev = this.vwHH1?.ansatzPj_haben ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

            if (!this.props.settings.doppelhaushalt && data.jahre.findIndex(d => d > this.props.jahr) >= 0) {
                columns.push({
                    dataField: '',
                    isDummyField: true,
                    headerAlign: 'middle',
                    headerFormatter: (column: any, columnIndex: any) => {
                        var ttId = "kslplus-tt-fpcol-vb" + (ausgaben ? "a" : "e");
                        return (<div>
                            <div id={ttId} className="kslplus-jahre-toggle">{this.state.fpJahre ? "-" : "+"}</div >
                            <UncontrolledPopover
                                placement="right"
                                target={ttId}
                                trigger="hover"
                                className="kslplus-header-popover">
                                <PopoverBody className="kslplus-header-popover-body">
                                    <Container>
                                        <div>
                                            {"Finanzplanjahre " + (this.state.fpJahre ? "verbergen" : "anzeigen")}
                                        </div>
                                    </Container>
                                </PopoverBody>
                            </UncontrolledPopover>
                        </div >);

                    },
                    text: this.state.fpJahre ? "-" : "+",
                    headerStyle: (colum: any, colIndex: any) => {
                        return { fontWeight: 900, width: '30px', textAlign: 'left' };
                    },

                    style: (colum: any, colIndex: any) => {
                        return { width: '30px' };
                    },
                    footer: -1,
                    headerEvents: {
                        onClick: (e: any, column: any, columnIndex: any) => { this.setState({ fpJahre: !this.state.fpJahre }) }
                    }
                });
            }

            if ((this.props.settings.doppelhaushalt || this.state.fpJahre) && data.jahre.findIndex(d => d == this.props.jahr + 1) >= 0 && totalSum.fp1_haben != null) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.fp1_haben != undefined ? totalSub.fp1_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumn("fp1_haben", this.props.jahr + 1, totalSum.fp1_haben - subhaben, this.vwHH1?.fp1_haben ?? 0, id));
                    else
                        columns.push(this.createDataColumn("fp1_haben", this.props.jahr + 1, totalSum.fp1_haben - subhaben, undefined, id));
                else
                    columns.push(this.createDataColumn("fp1_haben", this.props.jahr + 1, totalSum.fp1_haben - subhaben, undefined, id));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "fp1_haben", sumPrev, totalSum.fp1_haben - subhaben, false, id, totalSum.id, true, "Vorjahr", this.props.settings.doppelhaushalt ? true : false, false, sumGPrev, this.vwHH1?.fp1_haben ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "fp1_haben", sumPrev, totalSum.fp1_haben - subhaben, false, id, totalSum.id, true, "Vorjahr", this.props.settings.doppelhaushalt ? true : false));
                    id++;
                }
                fieldPrev = "fp1_haben";
                sumPrev = totalSum.fp1_haben - subhaben;
                sumGPrev = this.vwHH1?.fp1_haben ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

            if (this.props.settings.doppelhaushalt && data.jahre.findIndex(d => d > this.props.jahr) >= 0) {
                columns.push({
                    dataField: '',
                    isDummyField: true,
                    headerAlign: 'middle',
                    headerFormatter: (column: any, columnIndex: any) => {
                        var ttId = "kslplus-tt-fpcol-vb" + (ausgaben ? "a" : "e");
                        return (<div>
                            <div id={ttId} className="kslplus-jahre-toggle">{this.state.fpJahre ? "-" : "+"}</div >
                            <UncontrolledPopover
                                placement="right"
                                target={ttId}
                                trigger="hover"
                                className="kslplus-header-popover">
                                <PopoverBody className="kslplus-header-popover-body">
                                    <Container>
                                        <div>
                                            {"Finanzplanjahre " + (this.state.fpJahre ? "verbergen" : "anzeigen")}
                                        </div>
                                    </Container>
                                </PopoverBody>
                            </UncontrolledPopover>
                        </div >);

                    },
                    text: this.state.fpJahre ? "-" : "+",
                    headerStyle: (colum: any, colIndex: any) => {
                        return { fontWeight: 900, width: '30px', textAlign: 'left' };
                    },

                    style: (colum: any, colIndex: any) => {
                        return { width: '30px' };
                    },
                    footer: -1,
                    headerEvents: {
                        onClick: (e: any, column: any, columnIndex: any) => { this.setState({ fpJahre: !this.state.fpJahre }) }
                    }
                });
            }

            if (this.state.fpJahre && data.jahre.findIndex(d => d == this.props.jahr + 2) >= 0 && totalSum.fp2_haben != null) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.fp2_haben != undefined ? totalSub.fp2_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumn("fp2_haben", this.props.jahr + 2, totalSum.fp2_haben - subhaben, this.vwHH1?.fp2_haben ?? 0, id));
                    else
                        columns.push(this.createDataColumn("fp2_haben", this.props.jahr + 2, totalSum.fp2_haben - subhaben, undefined, id));
                else
                    columns.push(this.createDataColumn("fp2_haben", this.props.jahr + 2, totalSum.fp2_haben - subhaben, undefined, id));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "fp2_haben", sumPrev, totalSum.fp2_haben - subhaben, false, id, totalSum.id, true, "Vorjahr", false, false, sumGPrev, this.vwHH1?.fp2_haben ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "fp2_haben", sumPrev, totalSum.fp2_haben - subhaben, false, id, totalSum.id, true));
                    id++;
                }
                fieldPrev = "fp2_haben";
                sumPrev = totalSum.fp2_haben - subhaben;
                sumGPrev = this.vwHH1?.fp2_haben ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

            if (this.state.fpJahre && data.jahre.findIndex(d => d == this.props.jahr + 3) >= 0 && totalSum.fp3_haben != null) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.fp3_haben != undefined ? totalSub.fp3_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumn("fp3_haben", this.props.jahr + 3, totalSum.fp3_haben - subhaben, this.vwHH1?.fp3_haben ?? 0, id));
                    else
                        columns.push(this.createDataColumn("fp3_haben", this.props.jahr + 3, totalSum.fp3_haben - subhaben, undefined, id));
                else
                    columns.push(this.createDataColumn("fp3_haben", this.props.jahr + 3, totalSum.fp3_haben - subhaben, undefined, id));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "fp3_haben", sumPrev, totalSum.fp3_haben - subhaben, false, id, totalSum.id, true, "Vorjahr", false, false, sumGPrev, this.vwHH1?.fp3_haben ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "fp3_haben", sumPrev, totalSum.fp3_haben - subhaben, false, id, totalSum.id, true));
                    id++;
                }
                fieldPrev = "fp3_haben";
                sumPrev = totalSum.fp3_haben - subhaben;
                sumGPrev = this.vwHH1?.fp3_haben ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

            if (this.state.fpJahre && data.jahre.findIndex(d => d == this.props.jahr + 4) >= 0 && totalSum.fp4_haben != null) {
                var subhaben = (totalSub != null && totalSub !== undefined && totalSub.fp4_haben != undefined ? totalSub.fp4_haben : 0);
                if (gesamtHH)
                    if (!gesamtVWHH)
                        columns.push(this.createDataColumn("fp4_haben", this.props.jahr + 4, totalSum.fp4_haben - subhaben, this.vwHH1?.fp4_haben ?? 0, id));
                    else
                        columns.push(this.createDataColumn("fp4_haben", this.props.jahr + 4, totalSum.fp4_haben - subhaben, undefined, id));
                else
                    columns.push(this.createDataColumn("fp4_haben", this.props.jahr + 4, totalSum.fp4_haben - subhaben, undefined, id));
                id++;
                if (fieldPrev && id > 3) {
                    if (gesamtHH && !gesamtVWHH)
                        columns.push(this.createChangeColumn(fieldPrev, "fp4_haben", sumPrev, totalSum.fp4_haben - subhaben, false, id, totalSum.id, true, "Vorjahr", false, false, sumGPrev, this.vwHH1?.fp4_haben ?? 0));
                    else 
                        columns.push(this.createChangeColumn(fieldPrev, "fp4_haben", sumPrev, totalSum.fp4_haben - subhaben, false, id, totalSum.id, true));
                    id++;
                }
                fieldPrev = "fp4_haben";
                sumPrev = totalSum.fp4_haben - subhaben;
                sumGPrev = this.vwHH1?.fp4_haben ?? 0;
            }
            else {
                fieldPrev = undefined;
            }

        }
        return columns;
    }


    createTabItems = (tabs: KSLPlusAPI.Vbtab[]) => {
        var mainContentItems: JSX.Element[] = [];
        var mainNavItems: JSX.Element[] = [];

        for (var i = 0; i < tabs.length; i++) {
            const tabId = "tab" + i.toString();
            const tab = tabs[i];
            mainNavItems.push(
                <NavItem key={"kenav" + tabId}>
                    <NavLink active={this.state.activeMainTab === tabId} onClick={() => this.setState({ activeMainTab: tabId })} tabIndex={0} onKeyDown={(e) => { if (e.keyCode === 13) this.setState({ activeMainTab: tabId }); }}>
                        <div className="kslplus-reiter-text-hauptzeile">{tab.bezeichnung}</div>
                    </NavLink>
                </NavItem>
            );
            mainContentItems.push(
                <TabPane tabId={tabId} key={"ketab" + tabId}>
                    <VBTab modul={this.props.plantyp == 3 ? 1 : 0} tab={tabs[i]} datasets={this.dataSets} kunde={this.props.kunde} gemeinde={this.props.gemeinde} jahr={this.props.jahr} settings={this.props.settings} className="kslplus-haushaltstab-wrapper-bottom" isVisible={this.state.activeMainTab === tabId} />
                </TabPane>
            );
        }

        return { navItems: mainNavItems, contentItems: mainContentItems };
    }

    createTabItemsDropDown = (tabs: KSLPlusAPI.Vbtab[]) => {
        var mainContentItems: JSX.Element[] = [];
        var mainNavItems: JSX.Element[] = [];

        for (var i = 0; i < tabs.length; i++) {
            const tabId = "tab" + i.toString();
            const tab = tabs[i];
            mainNavItems.push(
                <DropdownItem active={this.state.activeMainTab === tabId} key={"datanav" + tabId} onClick={() => this.setState({ activeMainTab: tabId, dropDownOpen: false, tab: tab.bezeichnung ? tab.bezeichnung : "", activeDataTabId: tabId })}>
                    {tab.bezeichnung}
                </DropdownItem>

            );
            mainContentItems.push(
                <TabPane tabId={tabId} key={"ketab" + tabId}>
                    <VBTab modul={this.props.plantyp == 3 ? 1 : 0} tab={tabs[i]} datasets={this.dataSets} kunde={this.props.kunde} gemeinde={this.props.gemeinde} jahr={this.props.jahr} settings={this.props.settings} className="kslplus-haushaltstab-wrapper-bottom" isVisible={this.state.activeMainTab === tabId} />
                </TabPane>
            );
        }

        return { navItems: mainNavItems, contentItems: mainContentItems };
    }

    toggleDataDropDown = () => {
        if (!this.state.dropDownOpen && this.state.activeMainTab !== this.state.activeDataTabId)
            this.setState({ activeMainTab: this.state.activeDataTabId });
        else
            this.setState({ dropDownOpen: !this.state.dropDownOpen });
    }

    modifyTreeChart = (container: HTMLElement | null, chartWrapper: GoogleChartWrapper, data: GoogleDataTable | null, hoverrow: number = -1, mouseover: boolean = false, colors: string[] = _colors) => {

        if (!data || !container || chartWrapper.getChartType() != "TreeMap")
            return;



        // find existing / build new labels
        Array.prototype.forEach.call(container.getElementsByTagName('text'), (text) => {

            // nur elemente ohne added attribute sind orignal elemente
            if (text.getAttribute('text-anchor') === 'middle' && !text.getAttribute('added')) {

                var rect = text.parentNode.getElementsByTagName('rect')[0];

                var added = false;
                if (text.parentNode) {

                    text.parentNode.childNodes.forEach((c: any) => {
                        if (c.getAttribute("added")) {
                            added = true;
                        }
                    });
                }
                // exclude top node
                if (rect.getAttribute('fill') !== '#cccccc') {
                    // angezeigten Text ohne ... ermitteln
                    var val = text.textContent as string;
                    val = val.replace(/…+$/, "");

                    var color = colors[0];
                    var cVal = 0;
                    var found = false;
                    var rFound = -1;
                    for (var r = 0; r < data.getNumberOfRows(); r++) {
                        if ((data.getValue(r, 0) as string).startsWith(val)) {
                            rFound = r;
                            if (found) {    // wenn mehr als ein Eintrag gefunden wurden, wird nichts unternommen
                                found = false;
                                break;
                            }

                            found = true;
                        }

                    }

                    if (found) {
                        color = colors[data.getValue(rFound, 3) as number % 31];
                        cVal = data.getValue(rFound, 4) as number;
                    }
                    if (!added) {
                        rect.setAttribute('fill', color);
                        if (found) {
                            var textLabel = text.cloneNode()
                            textLabel.setAttribute('y', (parseFloat(text.getAttribute('y')) + parseFloat(text.getAttribute('font-size')) + 4).toString());
                            textLabel.textContent = Utilities.FormatCurrency(cVal, 1, 0, '.', ',') + "%";
                            textLabel.setAttribute('added', 'true');
                            text.parentNode.appendChild(textLabel);
                        }
                    }
                    else if (found && rFound == hoverrow) {    // Elemente wurden bereits hinzugefügt --> nur noch mouseover betrachten                        
                        Array.prototype.forEach.call(text.parentNode.getElementsByTagName('text'), (text) => {
                            text.setAttribute('fill', mouseover ? 'black' : 'white');
                        });
                    }

                }
            }

        });
    }

    createObserver = (container: HTMLElement, chartWrapper: GoogleChartWrapper, data: GoogleDataTable | null, colors: string[] = _colors) => {
        var observer = new MutationObserver((record, observer) => {
            //observer.disconnect();
            this.modifyTreeChart(container, chartWrapper, data, -1, false, colors);
            /*
            if (container) {
                this.createObserver(container, chartWrapper, data);
            }
            */
        });
        observer.observe(container, {
            childList: true,
            subtree: true
        });
    }

    createChart = (data: KSLPlusAPI.HaushaltsEbene | null | undefined, jahr: number, gruppen: number[] | undefined, ausgaben: boolean) => {
        const colors = Object.keys(this.props.settings.farben?.['TBFD'] ?? {}).map(key => this.props.settings.farben?.['TBFD']?.[key] ?? "");
        const slices = Object.keys(this.props.settings.farben?.['TBFD'] ?? {}).map(key => { return { color: this.props.settings.farben?.['TBFD']?.[key] ?? "" }; });

        if (this.state.chartTyp == 0) {
            const options = {
                backgroundColor: 'none',
                is3D: this.props.settings.tD3d,
                pieSliceText: this.props.settings.tdText,
                legend: { position: this.props.settings.tdLegend, labeledValueText: this.props.settings.tdText == "value" ? "percentage" : "value" },
                pieSliceTextStyle: { fontSize: this.props.settings.tdFontSize != -1 ? this.props.settings.tdFontSize : undefined },
                sliceVisibilityThreshold: 0.00001,
                slices: slices
            };
            var pieData: any[][];
            if (this.props.plantyp == 3 || this.props.plantyp == 4)
                pieData = Utilities.createPieDataJR(data, jahr, gruppen, ausgaben, this.props.plantyp === 4, this.props.settings.ubWinTEUR);
            else
                pieData = Utilities.createPieData(data, jahr, gruppen, ausgaben, this.props.plantyp === 4, this.props.settings.ubWinTEUR);

            return (<div className="ksl-grafik-container">
                <Chart
                    width="100%"
                    height={'300px'}
                    chartType="PieChart"
                    chartLanguage='de'
                    loader={<div>Loading Chart</div>}
                    data={pieData}
                    options={options}
                    formatters={[
                        {
                            type: 'NumberFormat',
                            column: 1,
                            options: {
                                fractionDigits: 0,
                                suffix: ' TEUR'
                            },
                        }]}
                    rootProps={{ 'data-testid': '2' }}
                />
                <Col>

                    <ImgButton tttext="Tortendiagramm" id={"grafik-torte-" + jahr.toString()} className="ksl-grafik-toggle-button" type="piechart" onClick={() => {
                        this.setState({ chartTyp: 0 });
                    }} />
                    <ImgButton tttext="Balkendiagramm" id={"grafik-balken-" + jahr.toString()} className="ksl-grafik-toggle-button" type="barcharthor" onClick={() => {
                        this.setState({ chartTyp: 1 });
                    }} />
                    <ImgButton tttext="Flächendiagramm" id={"grafik-flaeche-" + jahr.toString()} className="ksl-grafik-toggle-button" type="aereachart" onClick={() => {
                        this.setState({ chartTyp: 2 });
                    }} />

                </Col>
            </div>);
        }
        else if (this.state.chartTyp == 1) {
            var barData: any[][] | undefined;
            if (this.props.plantyp == 3 || this.props.plantyp == 4)
                barData = Utilities.createBarHorzDataJR(data, jahr, gruppen, ausgaben, this.props.settings.waehrung, this.props.plantyp === 4, colors);
            else
                barData = Utilities.createBarHorzData(data, jahr, gruppen, ausgaben, this.props.settings.waehrung, this.props.plantyp === 4, colors);

            return (<div className="ksl-grafik-container">
                <Chart
                    width="100%"
                    height={'300px'}
                    chartType="BarChart"
                    chartLanguage='de'
                    loader={<div>Loading Chart</div>}
                    data={barData}
                    options={{
                        bar: { groupWidth: "50%" },
                        legend: { position: "none" },
                        chartArea: { width: '50%' }

                    }}
                    rootProps={{ 'data-testid': '2' }}
                />
                <Col>

                    <ImgButton tttext="Tortendiagramm" id={"grafik-torte-" + jahr.toString()} className="ksl-grafik-toggle-button" type="piechart" onClick={() => {
                        this.setState({ chartTyp: 0 });
                    }} />
                    <ImgButton tttext="Balkendiagramm" id={"grafik-balken-" + jahr.toString()} className="ksl-grafik-toggle-button" type="barcharthor" onClick={() => {
                        this.setState({ chartTyp: 1 });
                    }} />
                    <ImgButton tttext="Flächendiagramm" id={"grafik-flaeche-" + jahr.toString()} className="ksl-grafik-toggle-button" type="aereachart" onClick={() => {
                        this.setState({ chartTyp: 2 });
                    }} />

                </Col>
            </div>);

        }
        else if (this.state.chartTyp == 2) {

            const chartEvents: ReactGoogleChartEvent[] = [
                {
                    eventName: "ready",
                    callback: (eventCallbackArgs: {
                        chartWrapper: GoogleChartWrapper;
                        controlWrapper?: GoogleChartControl;
                        props: ReactGoogleChartProps;
                        google: GoogleViz;
                        eventArgs: any;
                    }) => {
                        var container = document.getElementById(eventCallbackArgs.chartWrapper.getContainerId());


                        if (container && eventCallbackArgs.chartWrapper.getChartType() == "TreeMap") {
                            setTimeout(() => { this.modifyTreeChart(container, eventCallbackArgs.chartWrapper, eventCallbackArgs.chartWrapper.getDataTable(), -1, false, colors) }, 1);
                            this.createObserver(container, eventCallbackArgs.chartWrapper, eventCallbackArgs.chartWrapper.getDataTable());
                        }
                        google.visualization.events.addListener(eventCallbackArgs.chartWrapper.getChart(), "onmouseover", (e: { row: number }) => {
                            this.modifyTreeChart(container, eventCallbackArgs.chartWrapper, eventCallbackArgs.chartWrapper.getDataTable(), e.row, true, colors);
                        });
                        google.visualization.events.addListener(eventCallbackArgs.chartWrapper.getChart(), "onmouseout", (e: { row: number }) => {
                            this.modifyTreeChart(container, eventCallbackArgs.chartWrapper, eventCallbackArgs.chartWrapper.getDataTable(), e.row, false, colors);
                        });
                    }
                }
            ];

            var treeMapData: any[][];
            if (this.props.plantyp == 3 || this.props.plantyp == 4)
                treeMapData = Utilities.createTreeMapDataJR(data, jahr, gruppen, ausgaben, this.props.plantyp === 4);
            else
                treeMapData = Utilities.createTreeMapData(data, jahr, gruppen, ausgaben, this.props.plantyp === 4);

            var treeData = google.visualization.arrayToDataTable(treeMapData);

            var options = {

                fontColor: "white",
                generateTooltip: (row: number, size: number, value: number) => {
                    return '<div class="kslplus-treemap-tooltip">' +
                        treeData.getValue(row, 0) + '<br/>' +
                        Utilities.FormatCurrency(treeData.getValue(row, 2), 2, 3, ".", ",") + " " + this.props.settings.waehrung + " (" +
                        Utilities.FormatCurrency(treeData.getValue(row, 4), 1, 0, ".", ",") + "%)" +
                        '</div>';
                }
            };

            return (<div className="ksl-grafik-container">
                <Chart
                    width="100%"
                    height={'300px'}
                    chartType="TreeMap"
                    chartLanguage='de'
                    loader={<div>Loading Chart</div>}
                    data={treeMapData}
                    options={options}
                    rootProps={{ 'data-testid': '2' }}
                    chartEvents={chartEvents}
                />
                <Col>

                    <ImgButton tttext="Tortendiagramm" id={"grafik-torte-" + jahr.toString()} className="ksl-grafik-toggle-button" type="piechart" onClick={() => {
                        this.setState({ chartTyp: 0 });
                    }} />
                    <ImgButton tttext="Balkendiagramm" id={"grafik-balken-" + jahr.toString()} className="ksl-grafik-toggle-button" type="barcharthor" onClick={() => {
                        this.setState({ chartTyp: 1 });
                    }} />
                    <ImgButton tttext="Flächendiagramm" id={"grafik-flaeche-" + jahr.toString()} className="ksl-grafik-toggle-button" type="aereachart" onClick={() => {
                        this.setState({ chartTyp: 2 });
                    }} />

                </Col>
            </div>);

        }
        return null;
    }

    render() {

        if (!this.state.ready)
            return null;

        var barColors = ['#264d99', '#264d99', '#264d99', '#dc3912', '#dc3912', '#dc3912'];
        var abwColors = this.props.settings.farben?.['ABWD'] ?? {};
        var colors = Object.keys(this.props.settings.farben?.['TBFD'] ?? {}).map(key => this.props.settings.farben?.['TBFD']?.[key] ?? "");
        var tabItems = this.createTabItems(this.vbtabs);

        var agr: { data: any[], colors: any[] } = { data: [], colors: [] };
        var egr: { data: any[], colors: any[] } = { data: [], colors: [] };
        var max: any[] = [-Number.MAX_VALUE, -Number.MAX_VALUE];
        var min: any[] = [Number.MAX_VALUE, Number.MAX_VALUE];
        var graphOptAGR: { minG: number | undefined, maxG: number | undefined, min0: number | undefined, max0: number | undefined, min1: number | undefined, max1: number | undefined } = { minG: undefined, maxG: undefined, min0: undefined, max0: undefined, min1: undefined, max1: undefined };
        var graphOptEGR: { minG: number | undefined, maxG: number | undefined, min0: number | undefined, max0: number | undefined, min1: number | undefined, max1: number | undefined } = { minG: undefined, maxG: undefined, min0: undefined, max0: undefined, min1: undefined, max1: undefined };


        if (this.props.plantyp == 3 || this.props.plantyp == 4) {
            agr = Utilities.createBarDataJR(this.vwHH1, [4, 5, 6, 7, 8], true, this.props.jahr, min, max, this.props.settings.waehrung, this.props.plantyp == 4, colors);
            graphOptAGR = Utilities.calcGrapOptions(min, max, this.props.settings.nullAchseAnzeigen);
            egr = Utilities.createBarDataJR(this.vwHH1, [0, 1, 2], false, this.props.jahr, min, max, this.props.settings.waehrung, this.props.plantyp == 4, colors);
            graphOptEGR = Utilities.calcGrapOptions(min, max, this.props.settings.nullAchseAnzeigen);
        }

        var max: any[] = [-Number.MAX_VALUE, -Number.MAX_VALUE];
        var min: any[] = [Number.MAX_VALUE, Number.MAX_VALUE];
        var grDataVM: any[] = [];
        if (this.E3_1 && this.E9_1)
            grDataVM = this.props.plantyp == 3 ? Utilities.createGraphDataJR(this.E3_1, this.E9_1, null, null, this.props.jahr, min, max, this.props.settings.waehrung) : (this.props.plantyp == 4 ? Utilities.createGraphDataUH(this.E3_1, this.E9_1, null, null, this.props.jahr, min, max, this.props.settings.waehrung) : Utilities.createGraphData(this.E3_1, this.E9_1, null, null, this.props.jahr, min, max, this.props.settings.waehrung));
        var graphOptVM = Utilities.calcGrapOptions(min, max, this.props.settings.nullAchseAnzeigen);
        max = [-Number.MAX_VALUE, -Number.MAX_VALUE];
        min = [Number.MAX_VALUE, Number.MAX_VALUE];
        var grDataVW: any[] = [];
        if (this.E3_1 && this.E9_1)
            grDataVW = this.props.plantyp == 3 ? Utilities.createGraphDataJR(this.vwHH1, this.vwHH1, this.E3_1, this.E9_1, this.props.jahr, min, max, this.props.settings.waehrung) : (this.props.plantyp == 4 ? Utilities.createGraphDataUH(this.vwHH1, this.vwHH1, this.E3_1, this.E9_1, this.props.jahr, min, max, this.props.settings.waehrung) : Utilities.createGraphData(this.vwHH1, this.vwHH1, this.E3_1, this.E9_1, this.props.jahr, min, max, this.props.settings.waehrung));
        var graphOptVW = Utilities.calcGrapOptions(min, max, this.props.settings.nullAchseAnzeigen);

        var trendHidden = this.props.settings.trendlinieAnzeigen === false;

        var options = {
            backgroundColor: 'none',
            is3D: this.props.settings.tD3d,
            pieSliceText: this.props.settings.tdText,
            legend: { position: this.props.settings.tdLegend, labeledValueText: this.props.settings.tdText == "value" ? "percentage" : "value" },
            pieSliceTextStyle: { fontSize: this.props.settings.tdFontSize != -1 ? this.props.settings.tdFontSize : undefined },
            sliceVisibilityThreshold: 0.00001
        };

        return (
            <div className="kslplus-haushaltstab-wrapper-middle">
                <Nav tabs>
                    <NavItem id="kslplus-tab-verwaltungshaushalt-gesamt">
                        <NavLink active={this.state.activeMainTab === "1"} onClick={() => this.setState({ activeMainTab: "1" })} tabIndex={0} onKeyDown={(e) => { if (e.keyCode === 13) this.setState({ activeMainTab: "1" }); }}>
                            <div className="kslplus-reiter-text-hauptzeile">Verwaltungshaushalt gesamt</div>
                        </NavLink>
                    </NavItem>
                    {Utilities.createTTItem(this.props.settings, "verwaltungshaushalt-gesamt")}
                    <NavItem id="kslplus-tab-vermögenshaushalt-gesamt">
                        <NavLink active={this.state.activeMainTab === "2"} onClick={() => this.setState({ activeMainTab: "2" })} tabIndex={0} onKeyDown={(e) => { if (e.keyCode === 13) this.setState({ activeMainTab: "2" }); }}>
                            <div className="kslplus-reiter-text-hauptzeile">Vermögenshaushalt gesamt</div>

                        </NavLink>
                    </NavItem>
                    {Utilities.createTTItem(this.props.settings, "vermögenshaushalt-gesamt")}
                    {this.props.settings.hiddenTabs?.findIndex(ht => ht.typ === 21) === -1 &&
                        <>
                            <NavItem id="kslplus-tab-gesamthaushalt">
                                <NavLink active={this.state.activeMainTab === "3"} onClick={() => this.setState({ activeMainTab: "3" })} tabIndex={0} onKeyDown={(e) => { if (e.keyCode === 13) this.setState({ activeMainTab: "3" }); }}>
                                    <div className="kslplus-reiter-text-hauptzeile">Gesamthaushalt</div>

                                </NavLink>
                            </NavItem>
                            {Utilities.createTTItem(this.props.settings, "gesamthaushalt")}
                        </>
                    }
                    
                    {tabItems.navItems}
                </Nav>
                {this.vwHH1 != null && this.E3_1 !== undefined && this.E3_1 != null && this.E9_1 !== undefined && this.E9_1 != null ?
                    <TabContent activeTab={this.state.activeMainTab}>

                        <TabPane tabId="1">
                            <div className="kslplus-vbhaushalts-wrapper">
                                {this.state.alleJahre ?
                                    <Row>
                                        <div></div>
                                        <Col>
                                            <BootstrapTable ref={(n: any) => this.node1 = n} keyField='untergruppe' data={this.vwHH1 != null ? this.vwHH1.unterEbenen : []} columns={this.createColumns(this.vwHH1, this.vwHH1, this.E3_1, null, null, false)} hiddenRows={[3, 4, 5, 6, 7, 8, 9]} />
                                        </Col>

                                    </Row>
                                    :
                                    <Row>
                                        <Col>
                                            <BootstrapTable ref={(n: any) => this.node1 = n} keyField='untergruppe' data={this.vwHH1 != null ? this.vwHH1.unterEbenen : []} columns={this.createColumns(this.vwHH1, this.vwHH1, this.E3_1, null, null, false)} hiddenRows={[3, 4, 5, 6, 7, 8, 9]} />
                                        </Col>

                                    </Row>}
                                {this.state.alleJahre ?
                                    <Row>
                                        <div></div>
                                        <Col>
                                            <BootstrapTable ref={(n: any) => this.node2 = n} keyField='untergruppe' data={this.vwHH1 != null ? this.vwHH1.unterEbenen : []} columns={this.createColumns(this.vwHH1, this.vwHH1, this.E9_1, this.vwHH1, this.E3_1, true)} hiddenRows={[0, 1, 2, 3, 9]} />
                                        </Col>
                                    </Row>
                                    :
                                    <Row>
                                        <Col>
                                            <BootstrapTable ref={(n: any) => this.node2 = n} keyField='untergruppe' data={this.vwHH1 != null ? this.vwHH1.unterEbenen : []} columns={this.createColumns(this.vwHH1, this.vwHH1, this.E9_1, this.vwHH1, this.E3_1, true)} hiddenRows={[0, 1, 2, 3, 9]} />
                                        </Col>

                                    </Row>
                                }
                                {(this.props.plantyp !== 4 || !this.props.settings.keinePrognose) &&
                                    <div>
                                        {this.props.plantyp == 3 ?
                                            <Row>
                                                <Col>
                                                    <div className="kslplus-headline-third">{"Einnnahmen und Ausgaben des VWHH " + this.props.jahr.toString() + " - Abweichungen zwischen Ansatz und Ergebnis"}</div>
                                                </Col>
                                            </Row> : null
                                        }
                                        {this.props.plantyp == 3 ?
                                            <Row>
                                                <Col>
                                                    <div className="ksl-grafik-container">

                                                        <Chart
                                                            width="100%"
                                                            height={'400px'}
                                                            chartType="BarChart"
                                                            chartLanguage='de'
                                                            loader={<div>Loading Chart</div>}
                                                            data={Utilities.createBarDataAEAJR(this.vwHH1, this.E9_1, this.E3_1, abwColors, this.props.settings.waehrung)}
                                                            options={{

                                                                bar: { groupWidth: "50%" },
                                                                legend: { position: "none" },
                                                                chartArea: { width: '80%', left: '20%' },
                                                                hAxis: { gridlines: { count: 10 } }

                                                            }}

                                                            rootProps={{ 'data-testid': '2' }}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                            : null
                                        }
                                        {this.props.plantyp == 4 ?
                                            <Row>
                                                <Col>
                                                    <div className="kslplus-headline-third">{"Einnnahmen und Ausgaben des VWHH " + this.props.jahr.toString() + " - Abweichungen zwischen fortgeschriebenem Ansatz und Prognosewert (s. Spalte Prognose manuell)"}</div>
                                                </Col>
                                            </Row> : null
                                        }
                                        {this.props.plantyp == 4 ?
                                            <Row>
                                                <Col>
                                                    <div className="ksl-grafik-container">

                                                        <Chart
                                                            width="100%"
                                                            height={'400px'}
                                                            chartType="BarChart"
                                                            chartLanguage='de'
                                                            loader={<div>Loading Chart</div>}
                                                            data={Utilities.createBarDataAEAUH(this.vwHH1, this.E9_1, this.E3_1, abwColors, this.props.settings.waehrung)}
                                                            options={{

                                                                bar: { groupWidth: "50%" },
                                                                legend: { position: "none" },
                                                                chartArea: { width: '80%', left: '20%' },
                                                                hAxis: { gridlines: { count: 10 } }

                                                            }}

                                                            rootProps={{ 'data-testid': '2' }}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                            : null
                                        }
                                        {this.props.plantyp == 3 ?
                                            <Row>
                                                <Col>
                                                    <div className="kslplus-headline-third">{"Abweichungen der Einnahmen zwischen Ansatz und Ergebnis nach Hauptgruppen"}</div>
                                                    <div className="ksl-grafik-container  ksl-grafik-container-piechart">

                                                        <Chart
                                                            width="100%"
                                                            height={'400px'}
                                                            chartType="BarChart"
                                                            chartLanguage='de'
                                                            loader={<div>Loading Chart</div>}
                                                            data={Utilities.createAenderungsBarDataJR(this.vwHH1, [0, 1, 2], false, abwColors)}
                                                            options={{
                                                                legend: { position: "none" },
                                                                chartArea: { width: '70%', left: '30%' },
                                                                hAxis: { gridlines: { count: 10 } }
                                                            }}
                                                            formatters={[
                                                                {
                                                                    type: 'NumberFormat',
                                                                    column: 1,
                                                                    options: {
                                                                        suffix: ' TEUR'
                                                                    },
                                                                }]}
                                                            rootProps={{ 'data-testid': '2' }}
                                                        />
                                                    </div>
                                                </Col>


                                            </Row> : null
                                        }
                                        {this.props.plantyp == 3 ?
                                            <Row>
                                                <Col>
                                                    <div className="kslplus-headline-third">{"Abweichungen der Ausgaben zwischen Ansatz und Ergebnis nach Hauptgruppen"}</div>
                                                    <div className="ksl-grafik-container  ksl-grafik-container-piechart">

                                                        <Chart
                                                            width="100%"
                                                            height={'400px'}
                                                            chartType="BarChart"
                                                            chartLanguage='de'
                                                            loader={<div>Loading Chart</div>}
                                                            data={Utilities.createAenderungsBarDataJR(this.vwHH1, [4, 5, 6, 7, 8], true, abwColors)}
                                                            options={{
                                                                legend: { position: "none" },
                                                                chartArea: { width: '70%', left: '30%' },
                                                                hAxis: { gridlines: { count: 10 } }
                                                            }}
                                                            formatters={[
                                                                {
                                                                    type: 'NumberFormat',
                                                                    column: 1,
                                                                    options: {
                                                                        suffix: ' TEUR'
                                                                    },
                                                                }]}
                                                            rootProps={{ 'data-testid': '2' }}
                                                        />
                                                    </div>
                                                </Col>

                                            </Row> : null
                                        }
                                        {this.props.plantyp == 4 ?
                                            <Row>
                                                <Col>
                                                    <div className="kslplus-headline-third">{"Abweichungen der Einnahmen zwischen fortgeschriebenem Ansatz und Prognosewert (s. Spalte Prognose manuell) nach Hauptgruppen"}</div>
                                                    <div className="ksl-grafik-container  ksl-grafik-container-piechart">

                                                        <Chart
                                                            width="100%"
                                                            height={'400px'}
                                                            chartType="BarChart"
                                                            chartLanguage='de'
                                                            loader={<div>Loading Chart</div>}
                                                            data={Utilities.createAenderungsBarDataUH(this.vwHH1, [0, 1, 2], false, abwColors)}
                                                            options={{
                                                                legend: { position: "none" },
                                                                chartArea: { width: '70%', left: '30%' },
                                                                hAxis: { gridlines: { count: 10 } }
                                                            }}
                                                            formatters={[
                                                                {
                                                                    type: 'NumberFormat',
                                                                    column: 1,
                                                                    options: {
                                                                        suffix: ' TEUR'
                                                                    },
                                                                }]}
                                                            rootProps={{ 'data-testid': '2' }}
                                                        />
                                                    </div>
                                                </Col>


                                            </Row> : null
                                        }
                                        {this.props.plantyp == 4 ?
                                            <Row>
                                                <Col>
                                                    <div className="kslplus-headline-third">{"Abweichungen der Ausgaben zwischen fortgeschriebenem Ansatz und Prognosewert (s. Spalte Prognose manuell) nach Hauptgruppen"}</div>
                                                    <div className="ksl-grafik-container  ksl-grafik-container-piechart">

                                                        <Chart
                                                            width="100%"
                                                            height={'400px'}
                                                            chartType="BarChart"
                                                            chartLanguage='de'
                                                            loader={<div>Loading Chart</div>}
                                                            data={Utilities.createAenderungsBarDataUH(this.vwHH1, [4, 5, 6, 7, 8], true, abwColors)}
                                                            options={{
                                                                legend: { position: "none" },
                                                                chartArea: { width: '70%', left: '30%' },
                                                                hAxis: { gridlines: { count: 10 } }
                                                            }}
                                                            formatters={[
                                                                {
                                                                    type: 'NumberFormat',
                                                                    column: 1,
                                                                    options: {
                                                                        suffix: ' TEUR'
                                                                    },
                                                                }]}
                                                            rootProps={{ 'data-testid': '2' }}
                                                        />
                                                    </div>
                                                </Col>

                                            </Row> : null
                                        }

                                        <Row>
                                            <Col>
                                                <div className="kslplus-headline-third">{this.props.plantyp == 3 ? "Entwicklung der Ergebnisse der Einnahmen und Ausgaben des VWHH" : "Entwicklung der Einnahmen und Ausgaben des VWHH"}</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <div className="ksl-grafik-container">
                                                    <Chart
                                                        width="100%"
                                                        height={'300px'}
                                                        chartType="ComboChart"
                                                        chartLanguage='de'
                                                        loader={<div>Loading Chart</div>}
                                                        data={Utilities.filterTrendlineData(grDataVW, this.props.settings.trendlinieAnzeigen)}
                                                        options={{
                                                            colors: [this.props.settings.farben?.["EAD"]?.["E"] ?? "#264d99", this.props.settings.farben?.["EAD"]?.["A"] ?? '#dc3912', this.props.settings.farben?.["EAD"]?.["ÄndEP"] ?? '#ADD8E6', this.props.settings.farben?.["EAD"]?.["ÄndAP"] ?? '#FF7F7F'],
                                                            vAxes: { 0: { title: this.props.settings.waehrung, minValue: graphOptVW.minG, maxValue: graphOptVW.maxG, viewWindow: { max: graphOptVW.max0, min: graphOptVW.min0 } }, 1: trendHidden ? { ...Utilities.hiddenAxis, minValue: graphOptVW.minG, maxValue: graphOptVW.maxG, viewWindow: { max: graphOptVW.max1, min: graphOptVW.min1 } } : { title: '%', minValue: graphOptVW.minG, maxValue: graphOptVW.maxG, viewWindow: { max: graphOptVW.max1, min: graphOptVW.min1 } } },
                                                            hAxis: { title: 'Jahr' },
                                                            seriesType: 'bars',
                                                            series: Utilities.applyTrendlineHiding({ 0: { targetAxisIndex: 0 }, 1: { targetAxisIndex: 0 }, 2: { type: 'line', targetAxisIndex: 1 }, 3: { type: 'line', targetAxisIndex: 1 } }, trendHidden),
                                                        }}
                                                        formatters={Utilities.createFormatters(4, 2)}
                                                        rootProps={{ 'data-testid': '1' }}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <div className="kslplus-headline-third">{this.props.plantyp == 3 ? "Entwicklung der Ergebnisse der Einnahmen nach Hauptgruppen" : "Entwicklung der Einnahmen des VWHH nach Hauptgruppen"}</div>
                                            </Col>
                                        </Row>

                                        {this.props.plantyp == 3 || (this.props.plantyp == 4 && this.vwHH1.jahre && this.vwHH1.jahre.length > 3) ?
                                            <div>
                                                <Row>
                                                    {(!this.vwHH1.jahre || this.vwHH1.jahre.findIndex(j => j === this.props.jahr - 4) != -1) &&
                                                        <Col className="ksl-container-piechart3">
                                                            <div className="kslplus-headline-third">{"Ergebnis " + (this.props.jahr - 4).toString()}</div>
                                                            <div className="ksl-grafik-container  ksl-grafik-container-piechart">
                                                                {this.createChart(this.vwHH1, -4, [0, 1, 2], false)}
                                                            </div>
                                                        </Col>
                                                    }
                                                    {(!this.vwHH1.jahre || this.vwHH1.jahre.findIndex(j => j === this.props.jahr - 3) != -1) &&
                                                        <Col className="ksl-container-piechart3">
                                                            <div className="kslplus-headline-third">{"Ergebnis " + (this.props.jahr - 3).toString()}</div>
                                                            <div className="ksl-grafik-container ksl-grafik-container-piechart">
                                                                {this.createChart(this.vwHH1, -3, [0, 1, 2], false)}
                                                            </div>
                                                        </Col>
                                                    }
                                                    {(!this.vwHH1.jahre || this.vwHH1.jahre.findIndex(j => j === this.props.jahr - 2) != -1) &&
                                                        <Col className="ksl-container-piechart3">
                                                            <div className="kslplus-headline-third">{"Ergebnis " + (this.props.jahr - 2).toString()}</div>
                                                            <div className="ksl-grafik-container  ksl-grafik-container-piechart">

                                                                {this.createChart(this.vwHH1, -2, [0, 1, 2], false)}
                                                            </div>
                                                        </Col>
                                                    }
                                                </Row>
                                                <Row>
                                                    {(!this.vwHH1.jahre || this.vwHH1.jahre.findIndex(j => j === this.props.jahr - 1) != -1) &&
                                                        <Col className="ksl-container-piechart3">
                                                            <div className="kslplus-headline-third">{"Ergebnis " + (this.props.jahr - 1).toString()}</div>
                                                            <div className="ksl-grafik-container  ksl-grafik-container-piechart">

                                                                {this.createChart(this.vwHH1, -1, [0, 1, 2], false)}
                                                            </div>
                                                        </Col>
                                                    }
                                                    {(!this.vwHH1.jahre || this.vwHH1.jahre.findIndex(j => j === this.props.jahr) != -1) &&
                                                        <Col className="ksl-container-piechart3">
                                                            <div className="kslplus-headline-third">{(this.props.plantyp === 4 ? "Prognose " : "Ergebnis ") + (this.props.jahr).toString()}</div>
                                                            <div className="ksl-grafik-container ksl-grafik-container-piechart">

                                                                {this.createChart(this.vwHH1, 0, [0, 1, 2], false)}
                                                            </div>
                                                        </Col>
                                                    }

                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <div className="ksl-grafik-container">
                                                            <Chart
                                                                width="100%"
                                                                height={'300px'}
                                                                chartType="ComboChart"
                                                                chartLanguage='de'
                                                                loader={<div>Loading Chart</div>}
                                                                data={egr.data}
                                                                options={{
                                                                    colors: egr.colors,
                                                                    chartArea: { width: '70%', left: '10%' },
                                                                    vAxes: { 0: { title: this.props.settings.waehrung, minValue: graphOptEGR.minG, maxValue: graphOptEGR.maxG, viewWindow: { max: graphOptEGR.max0, min: graphOptEGR.min0 } } },
                                                                    hAxis: { title: 'Jahr' },
                                                                    seriesType: 'bars'
                                                                }}
                                                                formatters={Utilities.createFormatters(4, 2, egr.data)}
                                                                rootProps={{ 'data-testid': '2' }}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                            :
                                            <div>
                                                <Row>
                                                    {(!this.vwHH1.jahre || this.vwHH1.jahre.findIndex(j => j === this.props.jahr - 2) != -1) &&
                                                        <Col className={"ksl-container-piechart" + ((this.vwHH1.jahre && this.vwHH1.jahre.length < 4) ? this.vwHH1.jahre.length.toString() : "3")} >
                                                            <div className="kslplus-headline-third">{"Ergebnis " + (this.props.jahr - 2).toString()}</div>
                                                            <div className="ksl-grafik-container ksl-grafik-container-piechart">
                                                                {this.createChart(this.vwHH1, -2, [0, 1, 2], false)}
                                                            </div>
                                                        </Col>
                                                    }
                                                    {(!this.vwHH1.jahre || this.vwHH1.jahre.findIndex(j => j === this.props.jahr - 1) != -1) &&
                                                        <Col className={"ksl-container-piechart" + ((this.vwHH1.jahre && this.vwHH1.jahre.length < 4) ? this.vwHH1.jahre.length.toString() : "3")} >
                                                            <div className="kslplus-headline-third">{(this.props.plantyp === 4 ? "Ergebnis " : "Ansatz ") + (this.props.jahr - 1).toString()}</div>
                                                            <div className="ksl-grafik-container ksl-grafik-container-piechart">
                                                                {this.createChart(this.vwHH1, -1, [0, 1, 2], false)}
                                                            </div>
                                                        </Col>
                                                    }
                                                    {(!this.vwHH1.jahre || this.vwHH1.jahre.findIndex(j => j === this.props.jahr) != -1) &&
                                                        <Col className={"ksl-container-piechart" + ((this.vwHH1.jahre && this.vwHH1.jahre.length < 4) ? this.vwHH1.jahre.length.toString() : "3")} >
                                                            <div className="kslplus-headline-third">{(this.props.plantyp === 4 ? "Prognose " : "Ansatz ") + (this.props.jahr).toString()}</div>
                                                            <div className="ksl-grafik-container ksl-grafik-container-piechart">
                                                                {this.createChart(this.vwHH1, 0, [0, 1, 2], false)}
                                                            </div>
                                                        </Col>
                                                    }

                                                </Row>
                                                {(this.props.plantyp == 3 || this.props.plantyp == 4) &&
                                                    <Row>
                                                        <Col>
                                                            <div className="ksl-grafik-container">
                                                                <Chart
                                                                    width="100%"
                                                                    height={'300px'}
                                                                    chartType="ComboChart"
                                                                    chartLanguage='de'
                                                                    loader={<div>Loading Chart</div>}
                                                                    data={egr.data}
                                                                    options={{
                                                                        colors: egr.colors,
                                                                        chartArea: { width: '70%', left: '10%' },
                                                                        vAxes: { 0: { title: this.props.settings.waehrung, minValue: graphOptEGR.minG, maxValue: graphOptEGR.maxG, viewWindow: { max: graphOptEGR.max0, min: graphOptEGR.min0 } } },
                                                                        hAxis: { title: 'Jahr' },
                                                                        seriesType: 'bars'
                                                                    }}
                                                                    formatters={Utilities.createFormatters(4, 2, egr.data)}
                                                                    rootProps={{ 'data-testid': '2' }}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                }
                                            </div>
                                        }

                                        <Row>
                                            <Col>
                                                <div className="kslplus-headline-third">{this.props.plantyp == 3 ? "Entwicklung der Ergebnisse der Ausgaben nach Hauptgruppen" : "Entwicklung der Ausgaben des VWHH nach Hauptgruppen"}</div>
                                            </Col>
                                        </Row>

                                        {this.props.plantyp == 3 || (this.props.plantyp == 4 && this.vwHH1.jahre && this.vwHH1.jahre.length > 3) ?
                                            <div>
                                                <Row>
                                                    {(!this.vwHH1.jahre || this.vwHH1.jahre.findIndex(j => j === this.props.jahr - 4) != -1) &&
                                                        <Col className="ksl-container-piechart3">
                                                            <div className="kslplus-headline-third">{"Ergebnis " + (this.props.jahr - 4).toString()}</div>
                                                            <div className="ksl-grafik-container ksl-grafik-container-piechart">
                                                                {this.createChart(this.vwHH1, -4, [4, 5, 6, 7, 8], true)}
                                                            </div>
                                                        </Col>
                                                    }
                                                    {(!this.vwHH1.jahre || this.vwHH1.jahre.findIndex(j => j === this.props.jahr - 3) != -1) &&
                                                        <Col className="ksl-container-piechart3">
                                                            <div className="kslplus-headline-third">{"Ergebnis " + (this.props.jahr - 3).toString()}</div>
                                                            <div className="ksl-grafik-container ksl-grafik-container-piechart">
                                                                {this.createChart(this.vwHH1, -3, [4, 5, 6, 7, 8], true)}
                                                            </div>
                                                        </Col>
                                                    }
                                                    {(!this.vwHH1.jahre || this.vwHH1.jahre.findIndex(j => j === this.props.jahr - 2) != -1) &&
                                                        <Col className="ksl-container-piechart3">
                                                            <div className="kslplus-headline-third">{"Ergebnis " + (this.props.jahr - 2).toString()}</div>
                                                            <div className="ksl-grafik-container ksl-grafik-container-piechart">

                                                                {this.createChart(this.vwHH1, -2, [4, 5, 6, 7, 8], true)}
                                                            </div>
                                                        </Col>
                                                    }
                                                </Row>
                                                <Row>
                                                    {(!this.vwHH1.jahre || this.vwHH1.jahre.findIndex(j => j === this.props.jahr - 1) != -1) &&
                                                        <Col className="ksl-container-piechart3">
                                                            <div className="kslplus-headline-third">{"Ergebnis " + (this.props.jahr - 1).toString()}</div>
                                                            <div className="ksl-grafik-container ksl-grafik-container-piechart">

                                                                {this.createChart(this.vwHH1, -1, [4, 5, 6, 7, 8], true)}
                                                            </div>
                                                        </Col>
                                                    }
                                                    {(!this.vwHH1.jahre || this.vwHH1.jahre.findIndex(j => j === this.props.jahr) != -1) &&
                                                        <Col className="ksl-container-piechart3">
                                                            <div className="kslplus-headline-third">{(this.props.plantyp === 4 ? "Prognose " : "Ergebnis ") + (this.props.jahr).toString()}</div>
                                                            <div className="ksl-grafik-container ksl-grafik-container-piechart">
                                                                {this.createChart(this.vwHH1, 0, [4, 5, 6, 7, 8], true)}
                                                            </div>
                                                        </Col>
                                                    }
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <div className="ksl-grafik-container">
                                                            <Chart
                                                                width="100%"
                                                                height={'300px'}
                                                                chartType="ComboChart"
                                                                chartLanguage='de'
                                                                loader={<div>Loading Chart</div>}
                                                                data={agr.data}
                                                                options={{
                                                                    colors: agr.colors,
                                                                    chartArea: { width: '70%', left: '10%' },
                                                                    vAxes: { 0: { title: this.props.settings.waehrung, minValue: graphOptAGR.minG, maxValue: graphOptAGR.maxG, viewWindow: { max: graphOptAGR.max0, min: graphOptAGR.min0 } } },
                                                                    hAxis: { title: 'Jahr' },
                                                                    seriesType: 'bars'
                                                                }}
                                                                formatters={Utilities.createFormatters(4, 2, agr.data)}
                                                                rootProps={{ 'data-testid': '2' }}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                            :
                                            <div>
                                                <Row>
                                                    {(!this.vwHH1.jahre || this.vwHH1.jahre.findIndex(j => j === this.props.jahr - 2) != -1) &&
                                                        <Col className={"ksl-container-piechart" + ((this.vwHH1.jahre && this.vwHH1.jahre.length < 4) ? this.vwHH1.jahre.length.toString() : "3")} >
                                                            <div className="kslplus-headline-third">{"Ergebnis " + (this.props.jahr - 2).toString()}</div>
                                                            <div className="ksl-grafik-container ksl-grafik-container-piechart">
                                                                {this.createChart(this.vwHH1, -2, [4, 5, 6, 7, 8], true)}
                                                            </div>
                                                        </Col>
                                                    }
                                                    {(!this.vwHH1.jahre || this.vwHH1.jahre.findIndex(j => j === this.props.jahr - 1) != -1) &&
                                                        <Col className={"ksl-container-piechart" + ((this.vwHH1.jahre && this.vwHH1.jahre.length < 4) ? this.vwHH1.jahre.length.toString() : "3")} >
                                                            <div className="kslplus-headline-third">{(this.props.plantyp === 4 ? "Ergebnis " : "Ansatz ") + (this.props.jahr - 1).toString()}</div>
                                                            <div className="ksl-grafik-container ksl-grafik-container-piechart">
                                                                {this.createChart(this.vwHH1, -1, [4, 5, 6, 7, 8], true)}
                                                            </div>
                                                        </Col>
                                                    }
                                                    {(!this.vwHH1.jahre || this.vwHH1.jahre.findIndex(j => j === this.props.jahr) != -1) &&
                                                        <Col className={"ksl-container-piechart" + ((this.vwHH1.jahre && this.vwHH1.jahre.length < 4) ? this.vwHH1.jahre.length.toString() : "3")} >
                                                            <div className="kslplus-headline-third">{(this.props.plantyp === 4 ? "Prognose " : "Ansatz ") + (this.props.jahr).toString()}</div>
                                                            <div className="ksl-grafik-container ksl-grafik-container-piechart">
                                                                {this.createChart(this.vwHH1, 0, [4, 5, 6, 7, 8], true)}
                                                            </div>
                                                        </Col>
                                                    }

                                                </Row>
                                                {(this.props.plantyp == 3 || this.props.plantyp == 4) &&
                                                    <Row>
                                                        <Col>
                                                            <div className="ksl-grafik-container">
                                                                <Chart
                                                                    width="100%"
                                                                    height={'300px'}
                                                                    chartType="ComboChart"
                                                                    chartLanguage='de'
                                                                    loader={<div>Loading Chart</div>}
                                                                    data={agr.data}
                                                                    options={{
                                                                        colors: agr.colors,
                                                                        chartArea: { width: '70%', left: '10%' },
                                                                        vAxes: { 0: { title: this.props.settings.waehrung, minValue: graphOptAGR.minG, maxValue: graphOptAGR.maxG, viewWindow: { max: graphOptAGR.max0, min: graphOptAGR.min0 } } },
                                                                        hAxis: { title: 'Jahr' },
                                                                        seriesType: 'bars'
                                                                    }}
                                                                    formatters={Utilities.createFormatters(4, 2, agr.data)}
                                                                    rootProps={{ 'data-testid': '2' }}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </TabPane>
                        <TabPane tabId="2">
                            <div className="kslplus-vbhaushalts-wrapper">
                                {this.state.alleJahre ?
                                    <Row>
                                        <div></div>
                                        <Col>
                                            <BootstrapTable ref={(n: any) => this.node3 = n} keyField='untergruppe' data={this.vwHH1 != null ? this.vwHH1.unterEbenen : []} columns={this.createColumns(this.vwHH1, this.E3_1, null, null, null, false)} hiddenRows={[0, 1, 2, 4, 5, 6, 7, 8, 9]} />
                                        </Col>
                                    </Row>
                                    :
                                    <Row>
                                        <Col>
                                            <BootstrapTable ref={(n: any) => this.node3 = n} keyField='untergruppe' data={this.vwHH1 != null ? this.vwHH1.unterEbenen : []} columns={this.createColumns(this.vwHH1, this.E3_1, null, null, null, false)} hiddenRows={[0, 1, 2, 4, 5, 6, 7, 8, 9]} />
                                        </Col>
                                    </Row>
                                }
                                {this.state.alleJahre ?
                                    <Row>
                                        <div></div>
                                        <Col>
                                            <BootstrapTable ref={(n: any) => this.node4 = n} keyField='untergruppe' data={this.vwHH1 != null ? this.vwHH1.unterEbenen : []} columns={this.createColumns(this.vwHH1, this.E9_1, null, this.E3_1, null, true)} hiddenRows={[0, 1, 2, 3, 4, 5, 6, 7, 8]} />
                                        </Col>
                                    </Row>
                                    :
                                    <Row>
                                        <Col>
                                            <BootstrapTable ref={(n: any) => this.node4 = n} keyField='untergruppe' data={this.vwHH1 != null ? this.vwHH1.unterEbenen : []} columns={this.createColumns(this.vwHH1, this.E9_1, null, this.E3_1, null, true)} hiddenRows={[0, 1, 2, 3, 4, 5, 6, 7, 8]} />
                                        </Col>
                                    </Row>
                                }
                                {(this.props.plantyp !== 4 || !this.props.settings.keinePrognose) &&
                                    <div>
                                        {this.props.plantyp == 3 ?
                                            <Row>
                                                <Col>
                                                    <div className="kslplus-headline-third">{"Einnnahmen und Ausgaben des VMHH " + this.props.jahr.toString() + " - Abweichungen zwischen Ansatz und Ergebnis"}</div>
                                                </Col>
                                            </Row> : null
                                        }
                                        {this.props.plantyp == 3 ?
                                            <Row>
                                                <Col>
                                                    <div className="ksl-grafik-container">

                                                        <Chart
                                                            width="100%"
                                                            height={'400px'}
                                                            chartType="BarChart"
                                                            chartLanguage='de'
                                                            loader={<div>Loading Chart</div>}
                                                            data={Utilities.createBarDataVMAEAJR(this.E3_1, this.E9_1, abwColors, this.props.settings.waehrung)}
                                                            options={{

                                                                bar: { groupWidth: "50%" },
                                                                legend: { position: "none" },
                                                                chartArea: { width: '80%', left: '20%' }

                                                            }}

                                                            rootProps={{ 'data-testid': '2' }}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                            : null
                                        }
                                        {this.props.plantyp == 4 ?
                                            <Row>
                                                <Col>
                                                    <div className="kslplus-headline-third">{"Einnnahmen und Ausgaben des VMHH " + this.props.jahr.toString() + " - Abweichungen zwischen fortgeschriebenem Ansatz und Prognosewert (s. Spalte Prognose manuell)"}</div>
                                                </Col>
                                            </Row> : null
                                        }
                                        {this.props.plantyp == 4 ?
                                            <Row>
                                                <Col>
                                                    <div className="ksl-grafik-container">

                                                        <Chart
                                                            width="100%"
                                                            height={'400px'}
                                                            chartType="BarChart"
                                                            chartLanguage='de'
                                                            loader={<div>Loading Chart</div>}
                                                            data={Utilities.createBarDataVMAEAUH(this.E3_1, this.E9_1, abwColors, this.props.settings.waehrung)}
                                                            options={{

                                                                bar: { groupWidth: "50%" },
                                                                legend: { position: "none" },
                                                                chartArea: { width: '80%', left: '20%' }

                                                            }}

                                                            rootProps={{ 'data-testid': '2' }}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                            : null
                                        }
                                        <Row>
                                            <Col>
                                                <div className="kslplus-headline-third">{this.props.plantyp == 3 ? "Entwicklung der Ergebnisse der Einnahmen und Ausgaben des VMHH" : "Entwicklung der Einnahmen und Ausgaben des VMHH"}</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <div className="ksl-grafik-container">
                                                    <Chart
                                                        width="100%"
                                                        height={'300px'}
                                                        chartType="ComboChart"
                                                        chartLanguage='de'
                                                        loader={<div>Loading Chart</div>}
                                                        data={Utilities.filterTrendlineData(grDataVM, this.props.settings.trendlinieAnzeigen)}
                                                        options={{
                                                            colors: [this.props.settings.farben?.["EAD"]?.["E"] ?? "#264d99", this.props.settings.farben?.["EAD"]?.["A"] ?? '#dc3912', this.props.settings.farben?.["EAD"]?.["ÄndEP"] ?? '#ADD8E6', this.props.settings.farben?.["EAD"]?.["ÄndAP"] ?? '#FF7F7F'],
                                                            vAxes: { 0: { title: this.props.settings.waehrung, minValue: graphOptVM.minG, maxValue: graphOptVM.maxG, viewWindow: { max: graphOptVM.max0, min: graphOptVM.min0 } }, 1: trendHidden ? { ...Utilities.hiddenAxis, minValue: graphOptVM.minG, maxValue: graphOptVM.maxG, viewWindow: { max: graphOptVM.max1, min: graphOptVM.min1 } } : { title: '%', minValue: graphOptVM.minG, maxValue: graphOptVM.maxG, viewWindow: { max: graphOptVM.max1, min: graphOptVM.min1 } } },
                                                            hAxis: { title: 'Jahr' },
                                                            seriesType: 'bars',
                                                            series: Utilities.applyTrendlineHiding({ 0: { targetAxisIndex: 0 }, 1: { targetAxisIndex: 0 }, 2: { type: 'line', targetAxisIndex: 1 }, 3: { type: 'line', targetAxisIndex: 1 } }, trendHidden),
                                                        }}
                                                        formatters={Utilities.createFormatters(4, 2)}
                                                        rootProps={{ 'data-testid': '2' }}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                }
                            </div>

                        </TabPane>
                        <TabPane tabId="3">
                            <div className="kslplus-vbhaushalts-wrapper">
                                {this.state.alleJahre ?
                                    <Row>
                                        <div></div>
                                        <Col>
                                            <BootstrapTable ref={(n: any) => this.node1 = n} keyField='untergruppe' data={this.vwHH1 != null ? this.vwHH1.unterEbenen : []} columns={this.createColumns(this.vwHH1, this.vwHH1, this.E3_1, null, null, false, true, true)} hiddenRows={[3, 4, 5, 6, 7, 8, 9]} />
                                        </Col>

                                    </Row>
                                    :
                                    <Row>
                                        <Col>
                                            <BootstrapTable ref={(n: any) => this.node1 = n} keyField='untergruppe' data={this.vwHH1 != null ? this.vwHH1.unterEbenen : []} columns={this.createColumns(this.vwHH1, this.vwHH1, this.E3_1, null, null, false, true, true)} hiddenRows={[3, 4, 5, 6, 7, 8, 9]} />
                                        </Col>

                                    </Row>
                                }
                                {this.state.alleJahre ?
                                    <Row>
                                        <div></div>
                                        <Col>
                                            <BootstrapTable ref={(n: any) => this.node3 = n} keyField='untergruppe' data={this.vwHH1 != null ? this.vwHH1.unterEbenen : []} columns={this.createColumns(this.vwHH1, this.E3_1, null, null, null, false, true, false)} hiddenRows={[0, 1, 2, 4, 5, 6, 7, 8, 9]} />
                                        </Col>
                                    </Row>
                                    :
                                    <Row>
                                        <Col>
                                            <BootstrapTable ref={(n: any) => this.node3 = n} keyField='untergruppe' data={this.vwHH1 != null ? this.vwHH1.unterEbenen : []} columns={this.createColumns(this.vwHH1, this.E3_1, null, null, null, false, true, false)} hiddenRows={[0, 1, 2, 4, 5, 6, 7, 8, 9]} />
                                        </Col>
                                    </Row>
                                }
                                {this.state.alleJahre ?
                                    <Row>
                                        <div></div>
                                        <Col>
                                            <BootstrapTable ref={(n: any) => this.node2 = n} keyField='untergruppe' data={this.vwHH1 != null ? this.vwHH1.unterEbenen : []} columns={this.createColumns(this.vwHH1, this.vwHH1, this.E9_1, this.vwHH1, this.E3_1, true, true, true)} hiddenRows={[0, 1, 2, 3, 9]} />
                                        </Col>
                                    </Row>
                                    :
                                    <Row>
                                        <Col>
                                            <BootstrapTable ref={(n: any) => this.node2 = n} keyField='untergruppe' data={this.vwHH1 != null ? this.vwHH1.unterEbenen : []} columns={this.createColumns(this.vwHH1, this.vwHH1, this.E9_1, this.vwHH1, this.E3_1, true, true, true)} hiddenRows={[0, 1, 2, 3, 9]} />
                                        </Col>

                                    </Row>
                                }
                                
                                {this.state.alleJahre ?
                                    <Row>
                                        <div></div>
                                        <Col>
                                            <BootstrapTable ref={(n: any) => this.node4 = n} keyField='untergruppe' data={this.vwHH1 != null ? this.vwHH1.unterEbenen : []} columns={this.createColumns(this.vwHH1, this.E9_1, null, this.E3_1, null, true, true, false)} hiddenRows={[0, 1, 2, 3, 4, 5, 6, 7, 8]} />
                                        </Col>
                                    </Row>
                                    :
                                    <Row>
                                        <Col>
                                            <BootstrapTable ref={(n: any) => this.node4 = n} keyField='untergruppe' data={this.vwHH1 != null ? this.vwHH1.unterEbenen : []} columns={this.createColumns(this.vwHH1, this.E9_1, null, this.E3_1, null, true, true, false)} hiddenRows={[0, 1, 2, 3, 4, 5, 6, 7, 8]} />
                                        </Col>
                                    </Row>
                                }
                                
                            </div>
                        </TabPane>
                        {tabItems.contentItems}
                    </TabContent> : <div className="d-flex justify-content-center"> <Spinner color="primary" /></div>}

            </div>
        );
    }
}